export const common = {
  // Top Bar
  topBar: {
    freeShipping: 'KOSTENLOSER VERSAND - Bei allen Bestellungen',
    newMemberDiscount: '10% Rabatt für neue Mitglieder',
    securePayment: 'Sicheres Einkaufen',
  },

  // Header
  header: {
    shopNow: 'Jetzt Einkaufen',
  },

  // Navigation
  nav: {
    home: 'Startseite',
    women: 'DAMEN',
    men: 'HERREN',
    blog: 'BLOG',
    superSale: 'SUPER SALE',
    memberLogin: 'Mitgliederanmeldung',
    login: 'Anmelden',
    register: 'Registrieren',
    myOrders: 'Meine Bestellungen',
    myFavorites: 'Meine Favoriten',
    myCart: 'Mein Warenkorb',
    pages: 'Seiten',
    preferences: 'Einstellungen',
    myProfile: 'Mein Profil',
  },

  // Mega Menu
  megaMenu: {
    womenCollection: 'Damenkollektion',
    menCollection: 'Herrenkollektion',
    summerCollection: 'Sommerkollektion 2025',
    viewAll: 'Alle anzeigen',
    categories: 'KATEGORIEN',
    newSeason: 'NEUE SAISON',
    upToDiscount: 'Bis zu 70% Rabatt',
    exploreAll: 'Gesamte Kollektion entdecken',
    viewAllBtn: 'Alle anzeigen',
    securePayment: 'Sichere Zahlung',
    sslNote: 'Alle Ihre Zahlungen sind verschlüsselt und sicher.',
    sslBadge: '256-bit SSL',
    quickTags: {
      newArrivals: 'Neuankömmlinge',
      bestSelling: 'Bestseller',
      discounted: 'Reduziert',
      specialDesign: 'Sonderdesign',
    },
    womenSandals: 'Damen Sandalen',
    womenSandalsDesc: 'Sommerkollektion',
    womenClothing: 'Damenkleidung',
    womenClothingDesc: 'Trendstücke',
    womenShoes: 'Damenschuhe',
    womenShoesDesc: 'Für jeden Stil',
    womenBoots: 'Damenstiefel',
    womenBootsDesc: 'Schick & robust',
    womenSlippers: 'Damenhausschuhe',
    womenSlippersDesc: 'Bequem & stilvoll',
    womenBags: 'Damentaschen',
    womenBagsDesc: 'Saisonfavoriten',
    womenAccessories: 'Damenaccessoires',
    womenAccessoriesDesc: 'Ergänzende Stücke',
    womenCombo: 'Damen Kombi',
    womenComboDesc: 'Komplette Sets',
    menSandals: 'Herren Sandalen',
    menSandalsDesc: 'Sommerkollektion',
    menClothing: 'Herrenkleidung',
    menClothingDesc: 'Moderne Stile',
    menShoes: 'Herrenschuhe',
    menShoesDesc: 'Klassisch & sportlich',
    menBoots: 'Herrenstiefel',
    menBootsDesc: 'Stark & stilvoll',
    menSlippers: 'Herrenhausschuhe',
    menSlippersDesc: 'Täglicher Komfort',
    menBags: 'Herrentaschen',
    menBagsDesc: 'Arbeit & Freizeit',
    menAccessories: 'Herrenaccessoires',
    menAccessoriesDesc: 'Stildetails',
    menCombo: 'Herren Kombi',
    menComboDesc: 'Komplette Sets',
    comboBadge: 'Kombi',
    tshirt: 'T-Shirt',
    pants: 'Hosen',
    dress: 'Kleid',
    kimono: 'Kimono',
    crop: 'Crop',
    shirt: 'Hemd',
    skirt: 'Rock',
    shorts: 'Shorts',
    suit: 'Anzug',
    womenLabel: 'Damen',
    menLabel: 'Herren',
    collectionSuffix: 'Kollektion',
  },

  // Top Bar Messages
  topBarMessages: {
    msg1: 'KOSTENLOSER VERSAND - Bei allen Bestellungen | 10% Rabatt für neue Mitglieder',
    msg2: 'ORGANISCHE ERDUNG BAREFOOT SCHUHE STIEFEL SANDALEN',
    msg3: 'ZEIT FÜR ORGANISCHE MODE — ENTDECKE DIE NATÜRLICHKEIT',
    msg4: 'SUPER KOMBIS — VERPASSE KEINE ÜBERRASCHUNGSGESCHENKE BEVOR DER VORRAT ENDET',
  },

  // Quick Menu / Help Popup
  quickMenu: {
    title: 'Schnellzugriff',
    liveChat: 'Live-Chat',
    liveChatStatus: 'Jetzt aktiv ✓',
    liveSupport: 'Live-Support',
    liveSupportStatus: 'Jetzt aktiv',
    liveCall: 'Live-Gespräch',
    liveCallDesc: 'Sprachunterstützung',
    liveBroadcast: 'Live-Stream',
    liveBroadcastStatus: 'Jetzt live 🔴',
    liveBroadcastBadge: 'LIVE',
    sustainability: 'Nachhaltigkeit',
    sustainabilityDesc: '100% Bio 🌿',
    support247: '24/7 Kundendienst',
    scrollUp: 'Nach oben scrollen',
    menu: 'MENÜ',
    up: 'OBEN',
    dayMode: 'Tag',
    nightMode: 'Nacht',
    liveSupport: 'Live-Support',
    liveSupportStatus: 'Jetzt aktiv',
    socialMedia: 'Soziale Medien',
    pages: 'Seiten',
    support: 'Support',
    followUs: 'Folge Uns',
    wholesale: 'Großhandel',
  },

  search: {
    placeholder: 'Produkte suchen... (z.B. Sandalen, Stiefel, Kleid)',
    noResults: 'Keine Ergebnisse gefunden',
    viewAll: 'Alle "{{query}}" Produkte anzeigen',
    title: 'Suchen',
    shortLabel: 'Suche',
    close: 'Schließen',
    popular: 'Beliebte Suchen',
    resultsLabel: 'Gefundene Produkte',
    popularTerms: ['Sandalen', 'Stiefel', 'Kleid', 'Hausschuhe', 'Kombi'],
    searchPage: {
      resultsCount: 'Produkte gefunden',
      searchDesc: 'Finden Sie das gesuchte Produkt',
      sortBy: 'Sortieren nach',
      sortDefault: 'Standard',
      sortPriceLow: 'Preis: Niedrig bis Hoch',
      sortPriceHigh: 'Preis: Hoch bis Niedrig',
      sortDiscount: 'Höchster Rabatt',
      viewProduct: 'Produkt ansehen',
      tryOtherTerms: 'Versuchen Sie einen anderen Suchbegriff',
      loadMore: 'Mehr laden',
    },
  },

  // Popular Products nav link
  popularProductsNav: 'Beliebte Produkte',

  // Settings
  settings: {
    language: 'Sprache',
    currency: 'Währung',
    selectLanguage: 'Sprache wählen',
    selectCurrency: 'Währung wählen',
  },

  // Mobile Marquee
  marquee: {
    discount: '70% RABATT',
    combos: 'AUF KOMBIS',
    summer: 'SOMMER SPEZIAL',
  },

  // Home Page
  home: {
    bestSeller: 'BESTSELLER',
    specialCampaign: 'SONDERAKTION',
    featuredCombos: 'Empfohlene Kombi-Sets',
    featuredProducts: 'Empfohlene Produkte',
    exploreCategories: 'Kategorien entdecken',
    viewAllProducts: 'Alle Produkte anzeigen',
    viewAllCombos: 'Alle Kombis anzeigen',
    setContent: 'SET-INHALT',
    normalPrice: 'Normalpreis',
    comboPrice: 'Kombi-Preis',
    save: 'SPAREN',
    freeShippingBadge: 'Kostenloser Versand',
    viewDetails: 'Details anzeigen',
    // Where To Next
    whereToNextLabel: 'Kollektionen',
    whereToNextTitle: 'Wohin als Nächstes?',
    whereToNextSubtitle: 'Der einzige Schuh, den du für deine Reise brauchst!',
    whereToNextShop: 'Produkt ansehen',
    whereToNextBuy: 'JETZT KAUFEN',
    // Flash Sale
    flashSaleLabel: 'Blitzangebot',
    flashSaleTitle: 'Bis zu 70% Rabatt auf Aktionsangebote',
    flashSaleSubtitle: 'Begrenzter Vorrat — schnell zugreifen!',
    flashSaleViewAll: 'Alle anzeigen',
    flashSaleTimeLabel: 'Aktion endet in',
    flashSaleHour: 'Stunde',
    flashSaleMinute: 'Minute',
    flashSaleSecond: 'Sekunde',
    flashSaleNext: 'Nächste:',
    flashSaleRound: 'Runde',
    flashSaleStockRunning: 'Vorrat wird knapp',
    flashSaleSold: 'Verkauft',
    flashSaleBuy: 'Jetzt kaufen',
    flashSaleNewCampaign: 'Neue Aktion gestartet!',
    flashSaleNewCampaignSub: 'Nicht verpassen!',
    flashSaleCta: 'Kombis Entdecken',
    // Combo Packs
    comboPacksTitle: 'Kombi-Pakete',
    comboPacksSubtitle: 'Sparen Sie Zeit und Geld mit fertigen Kombis',
    comboPacksIn: 'Enthält:',
    comboPacksSaving: 'Ersparnis!',
    comboPacksViewAll: 'Alle Kombis anzeigen',
    // Explore Categories
    exploreCategoriesLabel: 'Kollektionen',
    exploreCategoriesSubtitle: 'Wählen Sie die Kollektion, die zu Ihrem Stil passt',
    // Category Cards
    catSlippers: 'Hausschuhe',
    catSlippersSub: 'Bequeme & Stilvolle Modelle',
    catSandals: 'Sandalen',
    catSandalsSub: 'Absatz- & Flachmodelle',
    catCombos: 'Outfits',
    catCombosSub: '1+1 Kombis ab $500',
    catDresses: 'Kleider',
    catDressesSub: 'Maxi, Midi & Mini Modelle',
    catVeganLeather: 'Veganes Leder',
    catVeganLeatherSub: 'Cruelty-Free Kollektion',
    catGenuineLeather: 'Echtes Leder',
    catGenuineLeatherSub: 'Premium Tier-Leder Produkte',
    catBadgeVegan: 'VEGAN',
    catBadgePremium: 'PREMIUM',
    // Categories Section
    categoriesSubtitle: 'Wählen Sie die passende Kategorie',
    // Recent Reviews
    recentReviewsTitle: 'Aktuelle Kundenbewertungen',
    recentReviewsSubtitle: 'Neueste Bewertungen von echten Käufern',
    recentReviewsViewAll: 'Alle Bewertungen',
    recentReviewsAvgScore: 'Durchschnittsbewertung',
    recentReviewsTotal: 'Bewertungen gesamt',
    recentReviewsVerified: 'Verifizierter Käufer',
    recentReviewsVerifiedBadge: 'Verifiziert',
    recentReviewsSizeLabel: 'Größe:',
    // Spring Banner
    springBannerSubtitle: 'Entdecken Sie neue Saisonkollektionen und vervollständigen Sie Ihren Stil',
    springCollectionsLabel: 'Kollektionen',
    // Video Banner
    videoBannerLabel: 'Kundenfavoriten',
    videoBannerTitle: 'Meistgelikte Produkte',
    videoBannerSubtitle: 'Unsere beliebtesten und bestbewerteten Produkte',
    videoBannerViewAll: 'Alle ansehen',
    videoBannerTimeLabel: 'Letzte 24 Stunden',
    videoBannerDesc: 'Top-Produkte aus der letzten Woche',
    // Hero
    heroStartingFrom: 'Ab',
    // Blog Preview
    blogBadge: 'Blog',
    blogTitle: 'Neueste Artikel',
    blogSubtitle: 'Inspirierende Inhalte zu Gesundheit, Mode und Nachhaltigkeit',
    blogViewAll: 'Alle Artikel ansehen',
    blogReadMore: 'Weiterlesen',
    blogReadTime: 'Min. Lesezeit',
    // Sustainability Banner
    sustBannerBadge: 'Nachhaltige Mode',
    sustBannerTitle: 'Wir sind Befürworter von',
    sustBannerTitleHighlight: 'Nachhaltigkeit & Bio',
    sustBannerDesc: 'Jede Naht, jede Farbe, jedes Material — ist Ausdruck unserer Wertschätzung für den Planeten und für Sie. Von GOTS-zertifizierter Bio-Baumwolle bis zu Pflanzenfarbstoffen — wir sind im Einklang mit der Natur.',
    sustBannerStat1Label: 'Weniger Wasser',
    sustBannerStat2Label: 'Bio-Materialien',
    sustBannerStat3Label: 'Chemische Farbstoffe',
    sustBannerCta1: 'Unsere Nachhaltigkeitsseite',
    sustBannerCta2: 'Bio-Kollektion',
    // Sustainability Preview
    sustPreviewBadge: 'Nachhaltigkeit',
    sustPreviewTitle: 'Aus der Natur,',
    sustPreviewTitleHighlight: 'Zurück zur Natur',
    sustPreviewSubtitle: 'Jedes Material, jeder Verpackungsschritt und jede Verpackung ist ein Beweis für unseren Respekt gegenüber Umwelt und Gesundheit.',
    sustPreviewViewAll: 'Gesamte Seite ansehen',
    sustPreviewCta: 'Unsere Nachhaltigkeitsphilosophie entdecken',
    sustPreviewCertsLabel: 'Unsere Zertifizierungen',
    sustPreviewCarbonLabel: 'CO₂-Fußabdruck',
    sustPreviewCarbonVal: 'Null Emissionen',
    // PC Slider
    pcSlide1Tag: '⚡ NEUE KOLLEKTION',
    pcSlide1Title: 'Sommertraum',
    pcSlide1TitleHighlight: 'Kollektion',
    pcSlide1Subtitle: 'Premium-Ledersandalen, die die Wärme des Mittelmeers zu Ihren Füßen bringen',
    pcSlide2Tag: '🔥 70% RABATT',
    pcSlide2Title: 'Boho Chic',
    pcSlide2TitleHighlight: 'Sommerkleider',
    pcSlide2Subtitle: 'Handgefertigte Boho-Kollektion, die Ihren freien Geist widerspiegelt — begrenzter Vorrat',
    pcSlide3Tag: '🌿 VEGAN-LEDER',
    pcSlide3Title: 'Nachhaltig',
    pcSlide3TitleHighlight: 'Luxusmode',
    pcSlide3Subtitle: 'Naturfreundliche, cruelty-free Premium-Vegan-Lederkollektion',
    pcSlide4Tag: '🍂 NEUE KOLLEKTION',
    pcSlide4Title: 'Herbst',
    pcSlide4TitleHighlight: 'Stiefel-Kollektion',
    pcSlide4Subtitle: 'Fühlen Sie den Geist des Herbstes mit handgefertigten Premium-Lederstiefeln — begrenzter Vorrat',
    pcSlide4Cta1: 'Damen Stiefel',
    pcSlide4Cta2: 'Herren Stiefel',
    // Mobile Slider
    mobileSlide1Title: '65% Rabatt auf Sommermode',
    mobileSlide1Subtitle: 'Bis zu 70% Rabatt auf Sommer-Outfits',
    mobileSlide2Title: 'Neue Kollektion',
    mobileSlide2Subtitle: 'Premium Ledersandalen & Hausschuhe',
    mobileSlide3Title: 'Herbst-Kollektion',
    mobileSlide3Subtitle: 'Handgefertigte Lederstiefel — Begrenzter Vorrat',
    // Promo Banner
    promoTitle: '1+1 Kombis',
    promoTitleHighlight: '70% Rabatt',
    promoSavings: '$1.800 sparen!',
    promoCta: 'Kombis Entdecken',
    promoDiscountBadge: '70% ERSPARNIS',
    // Square Banners
    squareBanner1Label: 'NEUE KOLLEKTION',
    squareBanner1Title: 'Sommer-\nKollektion',
    squareBanner2Label: 'BESTSELLER',
    squareBanner2Title: 'Pantoletten-\nKollektion',
    squareBanner3Label: 'SOMMER-TREND',
    squareBanner3Title: 'Sandalen-\nKollektion',
    squareBanner4Label: 'HERBST',
    squareBanner4Title: 'Stiefel-\nKollektion',
    // Editorial Banners
    editorialBannersLabel: 'Unsere Kollektionen',
    editorialBannersTitle: 'Sabah Season is Coming',
    editorialBanner2Label: 'Bestseller',
    editorialBanner2Title: 'Pattern Babas',
    editorialBanner2Subtitle: 'Wieder verfügbar für Frühling',
    editorialBanner3Label: 'Reise',
    editorialBanner3Title: 'Wohin als Nächstes?',
    editorialBanner3Subtitle: "O'ahus Nordküste",
    editorialBanner4Label: 'Handgefertigt',
    editorialBanner4Title: 'The Lido Sandal',
    editorialBanner4Subtitle: 'In Italien handgefertigt',
  },

  // Footer
  footer: {
    categories: 'Kategorien',
    customerService: 'Kundenservice',
    followUs: 'Folgen Sie uns',
    wholesale: 'Großhandel',
    aboutUs: 'Über uns',
    contact: 'Kontakt',
    faq: 'FAQ',
    returnPolicy: 'Rückgaberecht',
    privacyPolicy: 'Datenschutz',
    termsOfService: 'AGB',
    shippingInfo: 'Versandinfo',
    paymentMethods: 'Zahlungsmethoden',
    tagline: 'Vervollständigen Sie Ihren Stil mit hochwertigen und eleganten Produkten.',
    womenClothing: 'Damenbekleidung',
    womenShoes: 'Damenschuhe',
    menClothing: 'Herrenbekleidung',
    menShoes: 'Herrenschuhe',
    comboPacks: 'Kombi-Pakete',
    reviews: 'Bewertungen',
    videos: 'Videos',
    popularProducts: 'Beliebte Produkte',
    sustainability: 'Nachhaltigkeit',
    followUsDesc: 'Bleiben Sie über neue Kollektionen und Kampagnen informiert.',
    copyright: '© 2024 FentyBarefoot. Alle Rechte vorbehalten.',
    features: 'FUNKTIONEN',
    featuresNew: 'NEU',
    sustainabilityLabel: 'NACHHALTIGKEIT',
    reviewsLabel: 'BEWERTUNGEN',
    reviewsNew: 'NEU',
    videosLabel: 'VIDEOS',
    videosNew: 'NEU',
    returns: 'Rückgabe & Umtausch',
    sslShopping: 'Sicheres Einkaufen mit SSL',
    women: 'Damen',
    men: 'Herren',
    company: 'Unternehmen',
    womenSandals: 'Damen Sandalen',
    womenBoots: 'Damen Stiefel',
    womenSlippers: 'Damen Hausschuhe',
    womenBags: 'Damen Taschen',
    womenAccessories: 'Damen Accessoires',
    womenCombo: 'Damen Kombi',
    menSandals: 'Herren Sandalen',
    menBoots: 'Herren Stiefel',
    menSlippers: 'Herren Hausschuhe',
    menBags: 'Herren Taschen',
    menAccessories: 'Herren Accessoires',
    menCombo: 'Herren Kombi',
    termsConditions: 'AGB',
    privacyCookiePolicy: 'Datenschutz & Cookies',
    deliveryShipping: 'Lieferung & Versand',
    returnsExchanges: 'Rückgabe & Umtausch',
    allCategories: 'Alle Kategorien',
    addressesTitle: 'Unsere Büros',
    trOfficeName: 'Türkei Hauptsitz',
    trOfficeAddrLine1: 'Şehitkamil Mah., İpek Yolu Cad. No: 127/A',
    trOfficeAddrLine2: '27500 Gaziantep, Türkei',
    trTaxNo: 'Steuernr.: 1234567890',
    usOfficeName: 'USA Office',
    usOfficeAddrLine1: '1234 Broadway Avenue, Suite 500',
    usOfficeAddrLine2: 'New York, NY 10001, USA',
    usTaxId: 'Tax ID: 98-7654321',
    returnPolicyBtn: 'Rückgabe & Umtausch',
    sitemap: 'Seitenübersicht',
    securePaymentTitle: 'Sichere Zahlung',
    shippingPartnerTitle: 'Versandpartner',
    fastDelivery: 'Schnelle Lieferung',
    securityTitle: 'Sicherheit',
    encryptedShopping: 'Verschlüsseltes Einkaufen',
    httpsSecure: 'HTTPS Sicher',
    intlShippingTitle: 'Länder Internationaler Versand',
    intlShippingDesc: 'Schnelle und sichere Lieferung weltweit — Sendungsverfolgung inklusive',
    cargoPartner: 'Versandpartner',
    countries: 'Länder',
    businessDaysLabel: 'Werktage',
    trackingLabel: 'Verfolgung',
    marketplaceTitle: 'Wir Verkaufen auf Internationalen Marktplätzen',
    mobileShippingTitle: 'Länder Sicherer Versand',
    mobileShippingSubtitle: 'Sendungsverfolgung · 3–7 Werktage',
    mobileCargo: 'Fracht',
    mobileMarketplaceTitle: 'Internationale Marktplätze',
    newsletterTitle: 'Newsletter abonnieren',
    newsletterSubtitle: 'Erfahren Sie als Erster von neuen Kollektionen, exklusiven Angeboten und Sonderaktionen.',
    newsletterPlaceholder: 'E-Mail-Adresse eingeben',
    newsletterSubscribe: 'Abonnieren',
    newsletterSuccess: 'Danke! Sie haben erfolgreich abonniert. 🎉',
    newsletterPrivacy: 'Ihre Daten sind sicher. Sie können sich jederzeit abmelden.',
  },

  // Category Page
  category: {
    filter: 'Filtern',
    productsFound: 'Produkte gefunden',
    page: 'Seite',
    otherCategories: 'Andere Kategorien',
    showingProducts: 'Produkte angezeigt',
    of: 'von',
    subcat: {
      all: 'Alle', boots: 'Stiefel', clothing: 'Kleidung', shoes: 'Schuhe', sandals: 'Sandalen', slippers: 'Hausschuhe', bags: 'Taschen', accessories: 'Accessoires', combo: 'Kombi-Sets', tshirt: 'T-Shirt', pants: 'Hosen', dress: 'Kleid', kimono: 'Kimono', crop: 'Crop', shirt: 'Hemd', skirt: 'Rock', shorts: 'Shorts', suit: 'Anzug', set: 'Set',
    },
    meta: {
      women: 'Damen', womenClothing: 'Damenkleidung', womenSandals: 'Damen Sandalen', womenSlippers: 'Damen Hausschuhe', womenShoes: 'Damen Schuhe', womenBags: 'Damen Taschen', womenAccessories: 'Damen Accessoires', womenBoots: 'Damen Stiefel', womenCombo: 'Damen Kombi-Sets',
      tshirt: 'T-Shirt', pants: 'Hosen', dress: 'Kleid', kimono: 'Kimono', crop: 'Crop', shirt: 'Hemd', skirt: 'Rock', shorts: 'Shorts', suit: 'Anzug', set: 'Set',
      men: 'Herren', menClothing: 'Herrenkleidung', menSandals: 'Herren Sandalen', menSlippers: 'Herren Hausschuhe', menShoes: 'Herren Schuhe', menBags: 'Herren Taschen', menAccessories: 'Herren Accessoires', menBoots: 'Herren Stiefel', menCombo: 'Herren Kombi-Sets',
      menTshirt: 'Herren T-Shirt', menPants: 'Herren Hosen', menShirt: 'Herren Hemd', menShorts: 'Herren Shorts', menSuit: 'Herren Anzug',
      veganLeather: 'Veganleder', genuineLeather: 'Echtleder', combo: 'Kombis',
    },
  },
  
  // Product Page
  productPage: {
    notFound: 'Produkt nicht gefunden',
    backToHome: 'Zurück zur Startseite',
    reviews: 'Bewertungen',
    inStock: 'Auf Lager',
    save: 'Sparen',
    comboContent: 'Combo-Inhalt',
    youSave: 'Sie sparen',
    selectSize: 'Größe wählen',
    sizeGuide: 'Größentabelle',
    shoeSize: 'Größe wählen (US)',
    shoeSizeGuide: 'Größentabelle',
    quantity: 'Menge',
    addToCart: 'In den Warenkorb',
    added: 'Hinzugefügt!',
    selectOptions: 'Auswahl treffen!',
    buyNow: 'Jetzt kaufen',
    freeShipping: 'Kostenloser Versand',
    dayReturn: '30 Tage Rückgabe',
    securePayment: 'Sichere Zahlung',
    productDescription: 'Produktbeschreibung',
    features: 'Eigenschaften',
    similarProducts: 'Ähnliche Produkte',
    zoom: 'Vergrößern',
    zoomHint: 'Doppelklick oder Scrollen zum Vergrößern',
    shopAnywhere: 'Kaufen Sie dieses Produkt von überall',
    customerReviews: 'Kundenbewertungen',
    addedToCart: 'Produkt in den Warenkorb gelegt!',
    viewCart: 'Warenkorb anzeigen',
    home: 'Startseite',
    personalization: 'Personalisierung & Geschenkverpackung',
    personalizationNote: 'Notiz hinzufügen, Geschenkverpackung wählen',
    personalizationActive: 'Aktiv',
    shippingOption: 'Versandoption',
    freeShippingLabel: 'Kostenloser Versand',
    freeLabel: 'KOSTENLOS',
    estimatedDelivery: 'Voraussichtliche Lieferung:',
    businessDays: '(6 Werktage)',
    customsTax: 'Zollgebühr:',
    noExtraFee: 'Keine Extrakosten, alle Steuern inklusive!',
    missingSelection: 'Bitte treffen Sie folgende Auswahl:',
    notSelected: 'nicht ausgewählt',
    discount: 'RABATT',
    freeShippingBadge: 'KOSTENLOSER VERSAND',
    selectColor: 'Farbe wählen',
    sole: 'Sohle',
    selectOption: 'Option wählen',
    selected: 'Ausgewählt:',
    women: 'Damen',
    men: 'Herren',
    selectNumber: 'Größe auswählen',
    bestSellers: 'Meistverkaufte Produkte',
    bestSellersSubtitle: 'Stars der Woche',
    watchVideo: 'Video ansehen',
    closeEsc: 'ESC drücken zum Schließen',
    featureList: [
      'Premium-Qualitätsmaterial',
      'Bequeme Passform und Verwendung',
      'Langlebige Haltbarkeit',
      'Einfache Pflege und Reinigung',
      'Verschiedene Größenoptionen',
    ],
    descriptionText1: 'Dieses Produkt, eines der herausragenden Stücke unserer Sommerkollektion, vereint Eleganz und Komfort. Aus hochwertigen Materialien gefertigt, wurde es sorgfältig für eine langlebige Nutzung entworfen.',
    descriptionText2: 'Für den täglichen Gebrauch geeignet, bietet dieses Produkt sowohl ein komfortables als auch ein stilvolles Aussehen. Dieses Stück, das Sie in verschiedenen Kombinationen tragen können, wird ein unverzichtbarer Teil Ihrer Garderobe.',
    featuresTitle: 'Eigenschaften',
    notSureAboutSize: 'Größe unsicher?',
    fitOption: 'Passform-Option',
    wideFitLabel: 'Weite Passform',
    wideFitDesc: 'Bequemer & lockerer Schnitt',
    narrowFitLabel: 'Schmale Passform',
    narrowFitDesc: 'Anliegender & schlanker Schnitt',
    personalizationInlineTitle: 'Personalisierung',
    personalizationInlineLine1: 'Kann ohne Socken getragen werden, bequem und gesund.',
    personalizationInlineLine2: 'Für genaue Messungen können Sie Ihre Barfuß-Maße (Länge und Breite) in Zentimetern in diesen Bereich schreiben. Beispiel (24,5 CM x 9 CM)',
    personalizationInlineLine3: 'Es wird nach Ihren Wünschen hergestellt, weit oder schmal.',
  },
  
  // Super Sale Page
  superSale: {
    limitedTime: 'Zeitlich begrenzte Kampagne',
    live: 'LIVE',
    timeRemaining: 'Verbleibende Zeit',
    all: 'Alle',
    women: 'Damen',
    men: 'Herren',
    womenCombo: 'Damen Kombi',
    menCombo: 'Herren Kombi',
    sortBy: 'Sortieren',
    priceAsc: 'Preis: Niedrig bis Hoch',
    priceDesc: 'Preis: Hoch bis Niedrig',
    discountDesc: 'Rabatt: Hoch bis Niedrig',
    newest: 'Neueste',
    productsOnSale: 'Produkte im Angebot',
    totalDiscount: 'Gesamtrabatt',
    happyCustomers: 'Zufriedene Kunden',
    freeShipping: 'Kostenloser Versand',
    banner1Title: 'Beste Angebote der Saison',
    banner1Subtitle: 'Bis zu 70% Rabatt auf alle Kategorien',
    banner2Title: 'Letzte Stunden!',
    banner2Subtitle: 'In den Warenkorb legen, bevor es weg ist',
    // Countdown
    flashRound: 'Blitzangebot',
    flashBadge: '⚡ BLITZ',
    dailyRound: 'Tagesangebot',
    dailyBadge: '🔥 TÄGLICH',
    nightRound: 'Nacht-Kampagne',
    nightBadge: '🌙 NACHT',
    newCampaignStarted: 'Neue Kampagne gestartet!',
    dontMiss: 'Nicht verpassen!',
    nextCampaign: 'Nächste:',
    hours: 'STUNDEN',
    minutes: 'MINUTEN',
    seconds: 'SEKUNDEN',
    // SaleProductCard
    discount: 'RABATT',
    reviews: 'Bewertungen',
    stockStatus: 'Lagerbestand',
    stockLeft: 'Stück übrig!',
  },

  // Combo Page
  combo: {
    title: 'Kombi-Pakete',
    subtitle: 'Sparen Sie Zeit und Geld mit sorgfältig zusammengestellten Kombis. Passende Produkte in jedem Paket!',
    benefit1Title: 'Günstiger Preis',
    benefit1Desc: '20-30% günstiger als Einzelkauf',
    benefit2Title: 'Zeitersparnis',
    benefit2Desc: 'Schnelles Einkaufserlebnis mit fertigen Kombis',
    benefit3Title: 'Passende Produkte',
    benefit3Desc: 'Sorgfältig von Stylisten ausgewählte Kombis',
    comboBadge: 'Kombi-Paket',
    discountBadge: 'Rabatt',
    packageContains: 'Enthält:',
    savings: 'Ersparnis!',
    filterAll: 'Alle',
    filterWomen: 'Damen',
    filterMen: 'Herren',
    giftProduct: 'Geschenkprodukt',
  },

  // Blog Page
  blog: {
    title: 'Blog & Inhalte',
    subtitle: 'FentyBarefoot Blog',
    heroSubtitle: 'Informative Inhalte über Fußgesundheit, Barefoot-Philosophie, nachhaltige Mode und mehr',
    all: 'Alle',
    healthLife: 'Gesundheit & Leben',
    fashionTrend: 'Mode & Trend',
    careCleaning: 'Pflege & Reinigung',
    sustainability: 'Nachhaltigkeit',
    productKnowledge: 'Produktinfo',
    readMore: 'Weiterlesen',
    newsletterTitle: 'Verpassen Sie keine Blog-Updates',
    newsletterDesc: 'Melden Sie sich für unsere E-Mail-Liste an, um über neue Inhalte auf dem Laufenden zu bleiben',
    emailPlaceholder: 'Ihre E-Mail-Adresse',
    subscribe: 'Abonnieren',
    post1Title: 'Barefoot & Organik — Vorteile von Erdungsschuhen',
    post1Excerpt: 'Erdungsschuhe sind so gestaltet, dass sie die natürliche Struktur Ihrer Füße ergänzen und zu Ihrer Gesundheit beitragen. Der Treffpunkt von Barefoot-Philosophie und organischem Leben...',
    post1Category: 'Gesundheit & Leben',
    post1Date: '15. Juni 2024',
    post1ReadTime: '8 Min. Lesedauer',
    post2Title: 'Tipps zur Schuhpflege im Sommer',
    post2Excerpt: 'Wie sollten Sie Ihre Schuhe bei heißem Wetter schützen und sauber halten? Praktische Tipps für eine lange Lebensdauer...',
    post2Category: 'Pflege & Reinigung',
    post2Date: '10. Juni 2024',
    post2ReadTime: '5 Min. Lesedauer',
    post3Title: 'Den richtigen Schuh für die Fußgesundheit wählen',
    post3Excerpt: 'Worauf sollten Sie beim Schuhkauf achten, um die Fußgesundheit zu schützen? Expertenrat und Empfehlungen...',
    post3Category: 'Gesundheit & Leben',
    post3Date: '5. Juni 2024',
    post3ReadTime: '6 Min. Lesedauer',
    post4Title: 'Was sind Barefoot-Schuhe? Warum sollte man sie wählen?',
    post4Excerpt: 'Wie unterscheiden sich Barefoot-Schuhe von herkömmlichen Schuhen? Auswirkungen auf die Fußgesundheit und Einsatzgebiete...',
    post4Category: 'Produktinfo',
    post4Date: '1. Juni 2024',
    post4ReadTime: '7 Min. Lesedauer',
    post5Title: 'Schuh-Trends Sommer 2024',
    post5Excerpt: 'Welche Schuhmodelle stechen diesen Sommer hervor? Farbpaletten, Designdetails und Stilvorschläge...',
    post5Category: 'Mode & Trend',
    post5Date: '28. Mai 2024',
    post5ReadTime: '5 Min. Lesedauer',
    post6Title: 'Schuhe aus organischen Materialien',
    post6Excerpt: 'Nachhaltige Mode und umweltfreundliche Produktionsprozesse. Vorteile und Zukunft organischer Materialien...',
    post6Category: 'Nachhaltigkeit',
    post6Date: '22. Mai 2024',
    post6ReadTime: '6 Min. Lesedauer',
    post7Title: 'Zero-Drop-Schuhe: Die Revolution, die Ihre Haltung verändert',
    post7Excerpt: 'Zero-Drop-Design — kein Höhenunterschied zwischen Ferse und Zehe — unterstützt die natürliche Haltung und reduziert Rücken-, Knie- und Fußschmerzen. Aber ist dieser Unterschied wirklich so wichtig?',
    post7Category: 'Produktinfo',
    post7Date: '12. März 2025',
    post7ReadTime: '6 Min. Lesedauer',
    post8Title: 'Breite Zehenbox Schuhe und ihre Auswirkungen auf die Fußgesundheit',
    post8Excerpt: 'Schuhe mit schmaler Spitze sind seit Jahrzehnten die Hauptursache für Fußdeformitäten. Das breite Zehenbox-Design ermöglicht das natürliche Spreizen der Zehen...',
    post8Category: 'Gesundheit & Leben',
    post8Date: '5. Februar 2025',
    post8ReadTime: '7 Min. Lesedauer',
    post9Title: 'Barefoot-Wanderstiefel: Freiheit in der Natur',
    post9Excerpt: 'Mit Barefoot-Stiefeln auf Bergpfaden, in Wäldern und in natürlichem Gelände zu wandern ist ein ganz anderes Erlebnis. Sind Bodengefühl, Leichtigkeit und gesunde Biomechanik gleichzeitig möglich?',
    post9Category: 'Produktinfo',
    post9Date: '18. Januar 2026',
    post9ReadTime: '8 Min. Lesedauer',
    post10Title: 'Erdungsstiefel: Die Energie der Erde bei jedem Schritt',
    post10Excerpt: 'Erdungsstiefel mit leitfähem Kupferdetail verleihen Ihren Spaziergängen eine neue Dimension. Auch im Herbst und Winter können Sie frei laufen ohne den Erdungseffekt zu verlieren...',
    post10Category: 'Gesundheit & Leben',
    post10Date: '3. Oktober 2025',
    post10ReadTime: '7 Min. Lesedauer',
    post11Title: 'Nachhaltige Schuhtrends 2026: Die Materialien der Zukunft',
    post11Excerpt: 'Kaktus-Leder, Pilzmyzel, Fischleder und biologisch abbaubare Sohlen... Die nachhaltigen Schuhtrends 2026 sind nicht nur umweltfreundlich, sondern auch perfekt mit der Barefoot-Philosophie abgestimmt...',
    post11Category: 'Nachhaltigkeit',
    post11Date: '7. April 2026',
    post11ReadTime: '6 Min. Lesedauer',
    post12Title: 'Erdung und Schlafqualität: Was sagt die Wissenschaft?',
    post12Excerpt: 'Schlaflosigkeit ist eines der häufigsten Gesundheitsprobleme unserer Zeit. Wie verbessert die Erdungswissenschaft die Schlafqualität? Forschung zu Cortisol-Rhythmus, Melatonin und tiefen Schlafzyklen...',
    post12Category: 'Gesundheit & Leben',
    post12Date: '20. Januar 2026',
    post12ReadTime: '7 Min. Lesedauer',
    post13Title: 'Auswirkungen von Erdung auf Stress und Angst',
    post13Excerpt: 'Eine natürliche Lösung für Stress und Angst durch das moderne Leben: Erdung. Cortisol mit Earthing-Schuhen im Alltag ausbalancieren und die psychische Gesundheit unterstützen...',
    post13Category: 'Gesundheit & Leben',
    post13Date: '14. März 2026',
    post13ReadTime: '6 Min. Lesedauer',
    post14Title: 'Geschichte des Barfußlaufens: Vergleich mit der modernen Welt',
    post14Excerpt: 'Von 200.000 Jahren Barfuß-Evolution bis zu heutigen Dicksohlenschuhen... Wie hat der menschliche Körper diese Veränderung erfahren? Historischer Vergleich von Barfuß und moderner Schuhmode...',
    post14Category: 'Gesundheit & Leben',
    post14Date: '8. Februar 2026',
    post14ReadTime: '8 Min. Lesedauer',
    post15Title: 'Die Wissenschaft der Erdung: Forschung und Beweise',
    post15Excerpt: 'Ist wissenschaftlich bewiesen, dass Erdung Entzündungen reduziert, die Schlafqualität verbessert und vor chronischen Krankheiten schützt? Forschung, Sicherheit und Dauerratgeber...',
    post15Category: 'Gesundheit & Leben',
    post15Date: '1. April 2026',
    post15ReadTime: '9 Min. Lesedauer',
    post16Title: 'Grounding-Therapie bei Migräne und Kopfschmerzen',
    post16Excerpt: 'Die neuroinflammatorische Dimension der Migräne und die Auswirkungen des Groundings auf CGRP, Entzündung und Stressmechanismen. Grounding als natürlicher komplementärer Ansatz gegen Kopfschmerzen...',
    post16Category: 'Gesundheit & Leben',
    post16Date: '22. Mai 2026',
    post16ReadTime: '7 Min. Lesedauer',
    post17Title: 'Stadterdung: Techniken und Oberflächen',
    post17Excerpt: 'Ist Erdung auch beim Leben auf Beton und Asphalt möglich? Leitfähige Oberflächen in der Stadt, Parkroutinen und Erdungstechniken in der modernen Welt mit FentyBarefoots leitfähigen Modellen...',
    post17Category: 'Gesundheit & Leben',
    post17Date: '10. Juni 2026',
    post17ReadTime: '6 Min. Lesedauer',
    post18Title: 'Nachhaltige Mode für ein natürliches Leben',
    post18Excerpt: 'Die Bedeutung von Kleidung aus Bio-Baumwolle, Leinen und recycelbaren Materialien.',
    post18Category: 'Nachhaltigkeit',
    post18Date: '15. März 2026',
    post18ReadTime: '6 Min. Lesezeit',
    post19Title: 'Wege zur Reduzierung Ihres CO₂-Fußabdrucks',
    post19Excerpt: 'Methoden zur Reduzierung von CO₂-Emissionen im Alltag, Energiesparen und bewusster Konsum.',
    post19Category: 'Nachhaltigkeit',
    post19Date: '20. März 2026',
    post19ReadTime: '5 Min. Lesezeit',
    post20Title: 'Unterstützung für kriegsbetroffene Frauen und Kinder',
    post20Excerpt: 'Jeder Kauf schafft eine Wirkung. Die Spende eines Teils des Umsatzes stärkt die soziale Solidarität.',
    post20Category: 'Soziale Verantwortung',
    post20Date: '25. März 2026',
    post20ReadTime: '5 Min. Lesezeit',
    post21Title: 'Ein Baum für jeden: Grüne Zukunft',
    post21Excerpt: 'Mit jedem Kauf einen Beitrag zur Natur leisten und die Bedeutung von Aufforstungsprojekten.',
    post21Category: 'Umwelt',
    post21Date: '1. April 2026',
    post21ReadTime: '4 Min. Lesezeit',
    post22Title: 'Die Geschichte handgefertigter Lederprodukte',
    post22Excerpt: 'Traditionelle Produktionstechniken, der Wert des Handwerks und natürliche Qualitätsmaterialien.',
    post22Category: 'Produktinfo',
    post22Date: '5. April 2026',
    post22ReadTime: '7 Min. Lesezeit',
    post23Title: 'Gesundheitliche Vorteile von Bio-Stoffen',
    post23Excerpt: 'Chemikalienfreie Bio-Stoffe reduzieren das Allergierisiko mit hautfreundlichen Eigenschaften.',
    post23Category: 'Gesundheit & Leben',
    post23Date: '10. April 2026',
    post23ReadTime: '6 Min. Lesezeit',
    post24Title: 'Klimaneutrale Produktion: FentyBarefoots Umweltverpflichtung',
    post24Excerpt: 'Klimaneutrale Produktionsprozesse, Nutzung erneuerbarer Energie und messbarer Umwelteinfluss.',
    post24Category: 'Nachhaltigkeit',
    post24Date: '12. April 2026',
    post24ReadTime: '5 Min. Lesezeit',
    post25Title: 'Grüne Zukunft: Wir pflanzen 50.000+ Bäume',
    post25Excerpt: 'Mehr als 50.000 Bäume gepflanzt. Gesellschaftliches Umweltbewusstsein und unsere umweltfreundliche Markenvision.',
    post25Category: 'Umwelt',
    post25Date: '18. April 2026',
    post25ReadTime: '4 Min. Lesezeit',
    sustainabilityLabel: 'Nachhaltigkeit',
    socialLabel: 'Soziale Verantwortung',
    environmentLabel: 'Umwelt',
    sustainabilitySection: 'Nachhaltigkeit & Natürliches Leben',
    newLabel: 'Neu',
    allPostsLabel: 'Alle Beiträge',
    statFidan: 'Bäume gepflanzt',
    statCarbon: 'CO₂ reduziert',
    statPeople: 'Personen erreicht',
    statWaste: 'Abfall recycelt',
    impactTitle: 'Grüne Zukunft: 50.000+ Bäume gepflanzt',
    impactDesc: 'Ein Baum für die Natur mit jedem Kauf. Mit unseren Kunden haben wir bisher mehr als 50.000 Bäume gepflanzt.',
  },

  // Filter Sidebar
  filter: {
    filters: 'Filter',
    clear: 'Löschen',
    sorting: 'Sortierung',
    popular: 'Am beliebtesten',
    newest: 'Neueste',
    priceAsc: 'Preis: Niedrig bis Hoch',
    priceDesc: 'Preis: Hoch bis Niedrig',
    discount: 'Höchster Rabatt',
    topRated: 'Beste Bewertung',
    priceRange: 'Preisspanne',
    size: 'Größe',
    color: 'Farbe',
    black: 'Schwarz',
    white: 'Weiß',
    camel: 'Kamel',
    terracotta: 'Terrakotta',
    beige: 'Beige',
    green: 'Grün',
    cream: 'Creme',
    brown: 'Braun',
    navy: 'Marine',
    olive: 'Olivgrün',
    freeShipping: 'Kostenloser Versand',
    rating: 'Bewertung',
    ratingAll: 'Alle Bewertungen',
    rating45plus: '4,5+ Sterne',
    rating4plus: '4+ Sterne',
    rating3plus: '3+ Sterne',
    tags: 'Etiketten',
    tagBestSeller: 'Bestseller',
    tagNewSeason: 'Neue Saison',
    tagOrganic: 'Bio',
    tagVegan: 'Vegan',
    tagPremium: 'Premium',
    tagSpecialPrice: 'Sonderpreis',
  },

  // Reviews Section
  reviews: {
    title: 'Kundenbewertungen',
    reviewsCount: 'Bewertungen',
    writeReview: 'Bewertung schreiben',
    verified: 'Verifizierter Kauf',
    size: 'Größe',
    helpful: 'War diese Bewertung hilfreich?',
    yourRating: 'Ihre Bewertung',
    veryBad: 'Sehr schlecht',
    bad: 'Schlecht',
    average: 'Durchschnittlich',
    good: 'Gut',
    excellent: 'Ausgezeichnet',
    yourName: 'Ihr Name',
    namePlaceholder: 'Ihr vollständiger Name',
    purchasedSize: 'Gekaufte Größe',
    selectSize: 'Größe wählen (optional)',
    reviewTitle: 'Bewertungstitel',
    titlePlaceholder: 'Fassen Sie Ihre Bewertung zusammen',
    yourReview: 'Ihre Bewertung',
    reviewPlaceholder: 'Teilen Sie Ihre Erfahrung mit dem Produkt...',
    addPhotos: 'Fotos hinzufügen',
    maxPhotos: '(Maximal 5 Fotos)',
    photosSelected: 'Fotos ausgewählt. Zum Entfernen überfahren.',
    add: 'Hinzufügen',
    cancel: 'Abbrechen',
    submit: 'Bewertung absenden',
    submitted: 'Bewertung erhalten!',
    submittedMessage: 'Sie wird nach Überprüfung veröffentlicht. Vielen Dank!',
    customerFavorite: 'Kundenfavorit',
    filterAll: 'Alle',
    stars: 'Sterne',
    sortNewest: 'Neueste',
    sortOldest: 'Älteste',
    sortHighest: 'Höchste Bewertung',
    sortLowest: 'Niedrigste Bewertung',
    sortHelpful: 'Hilfreichste',
    resultsShowing: 'Bewertungen angezeigt',
    activeFilters: 'Filter aktiv',
    noReviewsFound: 'Keine Bewertungen gefunden',
    noReviewsDesc: 'Keine Bewertungen gefunden, die Ihren ausgewählten Filtern entsprechen. Bitte passen Sie Ihre Filter an.',
    clearFiltersBtn: 'Filter löschen',
    viewProduct: 'Produkt ansehen',
    color: 'Farbe:',
    womenClothing: 'Damenbekleidung',
    womenShoes: 'Damenschuhe',
    menClothing: 'Herrenbekleidung',
    menShoes: 'Herrenschuhe',
    copyright: '© 2025 Organic Fashion. Alle Rechte vorbehalten.',
    productReviewed: 'Bewertetes Produkt',
    sortLabel: 'Sortieren',
    allCategories: 'Alle Kategorien',
    moreFilters: 'Mehr Filter',
    featured: 'Empfohlen',
    reviewsShown: 'Bewertungen angezeigt',
    loadMore: 'Mehr laden',
    allLoaded: 'Alle Bewertungen geladen',
  },

  sustainability: {
    heroLabel: 'Bio-Mode · Nachhaltige Mode',
    heroTitle: 'Mode im Einklang mit der Natur',
    heroSubtitle: 'Mit Bio-Baumwolle, recycelten Materialien und ethischer Produktion schaffen wir Mehrwert für die Zukunft',
    heroExplore: 'Kollektion Entdecken',
    heroCerts: 'Unsere Zertifizierungen',
    heroScroll: 'Nach Unten Scrollen',
    statWater: 'Wassereinsparung',
    statPackaging: 'Recycelte Verpackung',
    statChemical: 'Chemikalienreduzierung',
    statHandmade: 'Handgefertigtes Produkt',
    manifestoLabel: 'Unser Manifest',
    manifestoTitle: 'Unsere Nachhaltige Modephilosophie',
    carbonNeutral: 'Klimaneutral',
    materialsLabel: 'Unsere Materialien',
    materialsTitle: 'Natürliche und Recycelte Materialien',
    materialsSubtitle: 'Wir verwenden umweltfreundliche Materialien in jedem Produkt',
    certsLabel: 'Zertifikate & Standards',
    certsTitle: 'Unsere Internationalen Zulassungen',
    certsSubtitle: 'Zertifikate, die unser Nachhaltigkeitsversprechen belegen',
    timelineLabel: 'Unsere Nachhaltigkeitsreise',
    timelineTitle: 'Jedes Jahr Besser',
    faqLabel: 'Häufig Gestellte Fragen',
    faqTitle: 'Was Sie Wissen Möchten',
    ctaTitle: 'Werden Sie Teil Nachhaltiger Mode',
    ctaSubtitle: 'Entdecken Sie unsere Bio- und Ethik-Produktionskollektion',
    ctaExplore: 'Kollektion Ansehen',
    ctaBlog: 'Unsere Blogbeiträge',
    footerDesc: 'Wir produzieren nachhaltige und ethische Mode im Einklang mit der Natur.',
    footerMaterials: 'Materialien',
    footerCerts: 'Zertifikate',
    footerCollections: 'Kollektionen',
    audioStarted: 'Mit weiblicher Stimme gestartet!',
    audioPlaying: 'WIRD ABGESPIELT',
    audioLanguages: 'Verfügbare Sprachen',
  },

  sustainabilitySpeech: {
    lang: 'de-DE',
    title: 'Nachhaltigkeit & Erdung — Audio-Erzählung',
    playLabel: 'Audio-Anleitung',
    stopLabel: 'Stopp',
    text: `Willkommen im FentyBarefoot Bio-Modeshop. Unsere Philosophie der Nachhaltigkeit und des natürlichen Lebens.

Im Einklang mit der Natur zu leben ist keine Wahl — es ist eine Verantwortung. Wir befürworten die Rückkehr zum Wesen des Menschen, zum Rhythmus der Natur und zu den wahren Bedürfnissen des Körpers, ohne uns von der Geschwindigkeit der modernen Welt mitreißen zu lassen. Jedes Produkt, das wir herstellen, spiegelt diese Philosophie wider.

Die Wirkung des Kontakts mit der Erde auf den menschlichen Körper ist seit Jahrhunderten bekannt. Deshalb sind unsere Erdungsschuhe nicht nur Schuhe — sie sind ein Weg, die Verbindung zur Natur wiederherzustellen. Dank der speziellen leitfähigen Sohlenstruktur helfen sie, die natürliche Energie des Körpers zu balancieren und den ganzen Tag über Komfort und Bewusstsein zu bieten.

Unsere Erdungsschuhe. Die Materialien unserer Schuhe werden sorgfältig ausgewählt. Naturleder und atmungsaktive Oberflächen. Leitfähige Sohlenstruktur. Handgefertigte Details. Materialien mit minimalem Chemikalieneinsatz. Jedes Paar wird mit Blick auf Ihre Gesundheit und unseren Planeten produziert. Unser Ziel ist es, Produkte anzubieten, die Sie der Natur näherbringen.

Natürliche und biologische Textilien. Die Baumwoll- und Leinenprodukte unserer Kollektion werden aus einhundert Prozent natürlichen Fasern hergestellt. Sie sind atmungsaktiv und hautfreundlich. Sie enthalten keine synthetischen oder schädlichen Chemikalien. Sie haben langlebige und zeitlose Designs. Natürliche Materialien wie Baumwolle und Leinen bieten Umweltsensibilität und maximalen Komfort.

Unsere Nachhaltigkeitspolitik. Nachhaltigkeit ist für uns kein Trend — sie ist das Fundament der Produktion. Herstellung nach dem Prinzip der Abfallvermeidung. Rohstoffe, die der Natur keinen Schaden zufügen. Handwerkliche Produktion mit lokalen Handwerkern. Minimale und recycelbare Verpackung. Bewusste und optimierte Logistik.

Warum wir? Weil wir nicht nur Produkte verkaufen. Wir bieten einen Lebensstil an. Wir priorisieren natürlichkeit und Einfachheit. Wir stellen Qualität vor schnellen Konsum. Jedes unserer Produkte ist das Ergebnis einer naturrespektierenden und bewussten Produktion.

Wir glauben, dass es möglich ist, weniger aber besser zu konsumieren. Wir laden Sie ein, sich uns auf dieser Reise zurück zur Natur anzuschließen.`,
  },

  liveChat: {
    title: 'FentyBarefoot Support',
    online: 'Online · Schnelle Antwort',
    hello: 'Hallo!',
    introDesc: 'Wir helfen Ihnen gerne. Geben Sie Ihren Namen ein, um zu beginnen.',
    namePlaceholder: 'Ihr Name (optional)',
    startChat: 'Chat starten',
    continueAsGuest: 'Als Gast fortfahren',
    welcomeMsg: 'Wie können wir Ihnen helfen? 😊',
    supportTeam: 'Support-Team',
    messagePlaceholder: 'Ihre Nachricht...',
    secureNote: 'Sichere Verbindung · Ihre Privatsphäre ist geschützt',
    voiceCall: 'Sprachanruf',
    typing: 'Schreibt...',
    // Call modal
    callTitle: 'Support-Hotline',
    callMinimize: 'Minimieren',
    callClose: 'Schließen',
    callConnecting: 'Verbindung wird hergestellt...',
    callConnected: 'Verbunden',
    callBusy: 'Derzeit Besetzt',
    callEnded: 'Anruf Beendet',
    callWaiting: 'Warte auf Mitarbeiter...',
    callBusyNote: 'Bitte versuchen Sie es später erneut',
    callLive: 'Live-Verbindung',
    callHangupNote: 'Drücken Sie die rote Taste, um den Anruf zu beenden',
    callMinBar: 'Support-Hotline',
    callExpand: 'Erweitern',
    incomingCallTitle: 'Eingehender Sprachanruf',
    incomingCallLine: 'FentyBarefoot Support-Hotline',
    incomingCallMsg: 'Ihr Kundenbetreuer ruft Sie an. Möchten Sie antworten?',
    accept: 'Annehmen',
    reject: 'Ablehnen',
    activeCallTitle: 'Anruf Aktiv',
    activeCallSub: 'FentyBarefoot Support',
    welcomeAnnouncement: 'Willkommen bei FentyBarefoot. Bitte warten Sie, unser Mitarbeiter wird sich gleich um Sie kümmern.',
    busyAnnouncement: 'Unser Kundenbetreuer ist gerade beschäftigt. Bitte versuchen Sie es später erneut.',
  },

  // Size Guide Audio
  sizeGuideAudio: {
    listenBtn: 'Audio-Anleitung',
    stopBtn: 'Stopp',
    bannerDesc: 'Messanweisungen anhören',
    playingLabel: 'Audio-Anleitung wird abgespielt...',
    stopDesc: 'Zum Anhalten klicken',
    shoeNarration: 'Bitte messen Sie Ihren nackten Fuß in Zentimetern, sowohl Länge als auch Breite. Die Breite wird an der breitesten Stelle des Fußes nahe den Zehen gemessen.',
    clothingNarration: 'Messen Sie Brust, Taille, Hüfte und Körpergröße in Zentimetern. Messen Sie die Brust an der breitesten Stelle mit heruntergelassenen Armen, die Taille an der schmalsten Stelle und die Hüfte an der breitesten Stelle.',
  },

  sizeGuide: {
    title: 'Größentabelle',
    subtitle: 'Nutzen Sie Ihre Maße, um die richtige Größe zu finden',
    women: 'Damen',
    men: 'Herren',
    kids: 'Kinder',
    size: 'Größe',
    bust: 'Brust',
    waist: 'Taille',
    hip: 'Hüfte',
    height: 'Größe',
    howToMeasure: 'Wie messen?',
    bustMeasure: 'Brustumfang',
    bustDesc: 'Arme herunterlassen, Maßband um den weitesten Punkt der Brust führen.',
    waistMeasure: 'Taillenumfang',
    waistDesc: 'An der schmalsten Punkt der Taille nach dem Ausatmen messen.',
    hipMeasure: 'Hüftumfang',
    hipDesc: 'Waagerecht an der breitesten Stelle der Hüfte messen.',
    tip: 'Tipp',
    tipMessage: 'Wenn Sie zwischen zwei Größen liegen, wählen Sie die größere.',
    disclaimer: 'Maße sind ungefähr und können je nach Produkt variieren.',
    gotIt: 'Verstanden',
    womenShoesLabel: 'Damen Sommerschuhe',
    menShoesLabel: 'Herren Sommerschuhe',
    womenClothingLabel: 'Damen Sommerkleidung',
    menClothingLabel: 'Herren Sommerkleidung',
    euColumn: 'EU-Größe',
    usWomenColumn: 'US Damen',
    usMenColumn: 'US Herren',
    ukColumn: 'UK',
    footColumn: 'Fuß',
    euLabel: 'EU',
    measureShoeTitle: 'Fußlänge messen',
    shoeStep1Title: 'Auf Papier stellen',
    shoeStep1Desc: 'Weißes Papier auf eine ebene Fläche legen und mit Socken darauf stellen.',
    shoeStep2Title: 'Fuß umreißen',
    shoeStep3Title: 'Länge messen',
    shoeStep2Desc: 'Stift aufrecht halten und um den Fuß von der Ferse bis zur längsten Zehe zeichnen.',
    shoeStep3Desc: 'In cm von der Ferse bis zur Spitze der längsten Zehe messen.',
    shoeStep4Title: 'In Tabelle suchen',
    shoeStep4Desc: 'Ihr cm-Maß in der Spalte "Fuß (cm)" oben finden.',
    shoeTip: 'Wenn Ihre Füße unterschiedliche Größen haben, nehmen Sie den größeren als Referenz.',
    measureClothingTitle: 'Körpermaße nehmen',
    bustDesc2: 'Waagerecht an der breitesten Stelle der Brust unter den Armen messen.',
    waistDesc2: 'An der schmalsten Stelle der Taille nach dem Ausatmen messen.',
    hipDesc2: 'Waagerecht an der breitesten Stelle der Hüfte messen.',
    heightDesc2: 'Von der Kopfoberseite bis zur Fußsohle gerade messen.',
    clothingTip: 'Maße mit einem flexiblen Maßband nehmen.',
    notSureTitle: 'Unsicher?',
    notSureDesc: 'Wenn Sie zwischen zwei Größen liegen, wählen Sie die größere. Wir bieten kostenlosen Rückversand.',
    toleranceNote: 'Maße können eine Toleranz von ±1 cm beinhalten.',
  },

  returnPolicyPopup: {
    title: 'Rückgabe- & Umtauschrichtlinie', subtitle: 'Einfache, schnelle und kostenlose Rückgabe', close: 'Schließen',
    point1Title: '30-Tage Rückgaberecht', point1Desc: 'Sie können Ihre Bestellung innerhalb von 30 Tagen kostenlos zurückgeben.',
    point2Title: 'Kostenloser Rückversand', point2Desc: 'Wir übernehmen alle Versandkosten für Rücksendungen.',
    point3Title: '5-7 Tage Erstattung', point3Desc: 'Ihre Zahlung wird innerhalb von 5-7 Werktagen erstattet.',
    point4Title: 'Einfacher Umtausch', point4Desc: 'Kostenloser Umtausch bei Größen- oder Farbänderungen.',
    point5Title: 'Originalverpackung Erforderlich', point5Desc: 'Das Produkt muss unbenutzte und in der Originalverpackung sein.',
    ctaBtn: 'Vollständige Rückgaberichtlinie', detailsLink: '/returns-exchanges',
  },

  faqPage: {
    title: 'Häufig Gestellte Fragen', subtitle: 'Antworten auf alle Ihre Fragen', breadcrumb: 'FAQ',
    searchPlaceholder: 'Frage suchen...', allCategories: 'Alle', catOrders: 'Bestellungen', catShipping: 'Versand', catReturns: 'Rückgabe & Umtausch', catProducts: 'Produkte', catPayments: 'Zahlung',
    noResults: 'Keine Ergebnisse gefunden', noResultsDesc: 'Versuchen Sie einen anderen Suchbegriff.',
    contactTitle: 'Noch Offene Fragen?', contactText: 'Unser Kundenservice steht Ihnen 24/7 zur Verfügung.', contactBtn: 'Live-Support',
  },

  returnsPage: {
    title: 'Rückgaberichtlinie', subtitle: 'Kostenlose Rücksendung innerhalb von 30 Tagen', breadcrumb: 'Rückgaberichtlinie',
    heroStat1Value: '30', heroStat1Label: 'Tage Rückgabefrist', heroStat2Value: 'Kostenlos', heroStat2Label: 'Rückversand', heroStat3Value: '5-7', heroStat3Label: 'Tage Erstattung',
    processTitle: 'Rückgabeprozess',
    step1Num: '01', step1Title: 'Rückgabeanfrage erstellen', step1Desc: 'Erstellen Sie eine Anfrage per E-Mail oder Live-Support.',
    step2Num: '02', step2Title: 'Genehmigung & Versandcode', step2Desc: 'Innerhalb von 24 Stunden erhalten Sie einen kostenlosen Versandcode.',
    step3Num: '03', step3Title: 'Produkt verpacken', step3Desc: 'Verpacken Sie das Produkt in seiner Originalverpackung.',
    step4Num: '04', step4Title: 'Bei UPS abgeben', step4Desc: 'Geben Sie das Paket beim nächsten UPS-Punkt ab.',
    step5Num: '05', step5Title: 'Erstattung erhalten', step5Desc: 'Ihre Zahlung wird innerhalb von 5-7 Werktagen erstattet.',
    eligibleTitle: 'Rückgabefähige Produkte', elig1: 'Unbenutzte Produkte in Originalverpackung', elig2: 'Produkte mit intakten Etiketten', elig3: 'Innerhalb von 30 Tagen nach Lieferung', elig4: 'Reduzierte Produkte (gleiche Bedingungen)',
    notEligibleTitle: 'Nicht Rückgabefähig', notElig1: 'Personalisierte Produkte', notElig2: 'Benutzte und gewaschene Produkte', notElig3: 'Anfragen nach 30 Tagen', notElig4: 'Produkte mit beschädigter Verpackung',
    ctaTitle: 'Rückgabe einleiten?', ctaText: 'Unser Kundenservice hilft Ihnen gerne.', ctaBtn: 'Rückgabeanfrage erstellen',
  },

  shippingPage: {
    title: 'Versand & Lieferung', subtitle: 'Sichere, schnelle und verfolgbare Lieferung mit UPS', breadcrumb: 'Versand & Lieferung',
    upsBadge: 'Offizieller UPS Geschäftspartner', upsDesc: 'Wir liefern alle Ihre Bestellungen sicher durch die Zusammenarbeit mit UPS.',
    avgDelivery: '6 Werktage', avgDeliveryLabel: 'Internationaler Durchschnitt',
    trackingTitle: 'Echtzeit-Tracking', trackingDesc: 'Wir stellen für jede Bestellung eine UPS-Sendungsnummer bereit.',
    domesticTitle: 'Inlandslieferung (Türkei)', domesticDesc: 'Kostenloser Versand für alle Bestellungen in die Türkei.',
    dom1Title: 'Standard UPS Versand', dom1Time: '3-5 Werktage', dom1Price: 'Kostenlos',
    dom2Title: 'UPS Express', dom2Time: '1-2 Werktage', dom2Price: '₺29,90',
    dom3Title: 'Gleichtag (Istanbul)', dom3Time: 'Bestelltag', dom3Price: '₺49,90',
    intlTitle: 'Internationale Lieferung', intlDesc: 'Lieferung in über 50 Länder via UPS.',
    zoneEurope: 'Europa', zoneEuropeTime: '6-10 Werktage', zoneEuropePrice: 'Kostenlos (150€+) / 12€',
    zoneUSA: 'USA & Kanada', zoneUSATime: '6-10 Werktage', zoneUSAPrice: 'Kostenlos ($200+) / $18',
    zoneMiddleEast: 'Naher Osten', zoneMiddleEastTime: '8-12 Werktage', zoneMiddleEastPrice: '$15',
    zoneOther: 'Andere Länder', zoneOtherTime: '10-15 Werktage', zoneOtherPrice: 'Bitte kontaktieren Sie uns',
    packagingTitle: 'Umweltfreundliche Verpackung', packagingDesc: 'Alle Bestellungen werden in 100% recycelten Materialien versendet.',
    faqTitle: 'Versand FAQ',
    faq1Q: 'Wann wird meine Bestellung versandt?', faq1A: 'Bestellungen werden innerhalb von 1-2 Werktagen an UPS übergeben.',
    faq2Q: 'Wie nutze ich meine UPS Sendungsnummer?', faq2A: 'Geben Sie die Nummer auf ups.com ein oder nutzen Sie die UPS App.',
    faq3Q: 'Kann ich die Lieferadresse ändern?', faq3A: 'Sie können die Adresse vor dem Versand ändern.',
    faq4Q: 'Was passiert bei fehlgeschlagener Lieferung?', faq4A: 'UPS versucht die Zustellung 3 Mal. Danach wird das Paket beim nächsten UPS-Punkt hinterlegt.',
    ctaTitle: 'Fragen zum Versand?', ctaText: 'Unser Kundenservice ist 24/7 erreichbar.', ctaBtn: 'Live-Support',
  },

  favorites: {
    title: 'Meine Favoriten',
    itemsCount: 'Produkte vorgemerkt',
    emptyTitle: 'Ihre Favoritenliste ist leer',
    emptySubtitle: 'Noch keine Lieblingsprodukte hinzugefügt',
    emptyDesc: 'Klicken Sie auf das Herz-Symbol bei Produkten, die Ihnen gefallen, um sie zu Favoriten hinzuzufügen. Kein Konto erforderlich!',
    startShopping: 'Einkaufen starten',
    clearAll: 'Alle löschen',
    remove: 'Aus Favoriten entfernen',
    viewProduct: 'Produkt ansehen',
    suggestionsTitle: 'Erkunden Sie unsere Kollektionen',
    clearConfirmTitle: 'Alle Favoriten löschen?',
    clearConfirmDesc: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Ihre Lieblingsprodukte werden gelöscht.',
    clearConfirmBtn: 'Ja, löschen',
    cancel: 'Abbrechen',
    addedToFavorites: 'Zu Favoriten hinzugefügt!',
    removedFromFavorites: 'Aus Favoriten entfernt',
  },

  returnPolicyAudio: {
    lang: 'de-DE',
    listenBtn: 'Audio-Anleitung hören',
    stopBtn: 'Stopp',
    desc: 'Rückgabe- und Umtauschrichtlinie anhören',
    playingDesc: 'Audioerzählung wird abgespielt...',
    narration: 'Hallo! Ich möchte Ihnen die Rückgabe- und Umtauschrichtlinie von FentyBarefoot erläutern. Sie können Ihre Produkte innerhalb von dreißig Tagen nach Erhalt kostenlos zurückgeben. Wir übernehmen alle Rücksendekosten. Sobald wir Ihr zurückgesendetes Produkt erhalten, wird Ihre Zahlung innerhalb von fünf bis sieben Werktagen vollständig auf Ihre ursprüngliche Zahlungsmethode erstattet. Wenn Sie Größe oder Farbe ändern möchten, können Sie Ihr kostenloses Umtauschrecht nutzen. Für eine Rückgabe oder einen Umtausch muss das Produkt unbenutzt, mit intakten Etiketten und in der Originalverpackung sein. Bei Fragen steht Ihnen unser 24-Stunden-Live-Support jederzeit zur Verfügung. Vielen Dank!',
  },

  ugcGallery: {
    badge: 'Kundenfotos',
    title: 'Von Euch',
    subtitle: 'FentyBarefoot durch die Augen unserer Kunden aus aller Welt — echte Menschen, echte Momente.',
    shareText: 'Teile auch deine FentyBarefoot-Erfahrung!',
    shareBtn: 'Mit #FentyBarefoot teilen',
    prevBtn: 'Zurück',
    nextBtn: 'Weiter',
  },

  podiatristSection: {
    title: 'Expertenmeinungen von Podologen',
    subtitle: 'International anerkannte Podologen teilen ihre wissenschaftlichen Erkenntnisse und klinischen Beobachtungen zur FentyBarefoot-Erdungstechnologie.',
    listenBtn: 'Anhören',
    stopBtn: 'Stopp',
    statDoctors: 'Experten-Ärzte',
    statStudies: 'Klinische Studien',
    statPatients: 'Patientenbeobachtungen',
    disclaimer: 'Expertenmeinungen basieren auf persönlichen klinischen Erfahrungen. Individuelle Ergebnisse können variieren.',

    doctor1Name: 'Dr. Mehmet Yılmaz',
    doctor1Title: 'Podologe | Istanbul Medizinische Fakultät',
    doctor1Quote: 'Das Erden ist nicht nur ein Schritt — es ist eine echte Verbindung, die Sie mit der Natur aufbauen. Jedes Mal, wenn ein Patient dies erlebt, kann ich dieVerwandlung spüren.',
    doctor1Narration: 'Barefoot-Erdungsschuhe wurden entwickelt, um Sie zurück zum Wesen der Natur zu bringen. Anstatt der isolierten Sohlen des modernen Lebens spüren Sie die Kraft des natürlichen Kontakts. Dank kupferleitender Details erreicht die Energie der Erde direkt Ihren Körper. Negative Ladungen werden ausgeglichen, Ihr Körper kehrt zu seinem natürlichen Rhythmus zurück. Erdung... Es ist nicht nur Gehen, es ist Fühlen. Es ist nicht nur Schreiten, es ist Verbindung mit der Welt. Ihre Seele beruhigt sich, Ihr Körper fühlt sich leichter an... Mit jedem Schritt fühlen Sie sich ausgeglichener, energiegeladener. Natürlich. Rein. Real. Mit Barefoot-Erdungsstiefeln entdecken Sie Ihre Energie neu.',

    doctor2Name: 'Dr. Sarah Johnson',
    doctor2Title: 'Fuß- und Sprunggelenk-Spezialistin | London Foot Clinic',
    doctor2Quote: 'Ihre Füße sind die vernachlässigsten Organe Ihres Körpers. Die Barefoot-Philosophie gibt ihnen die Freiheit zurück, die sie verdienen.',
    doctor2Narration: 'Fußbiomechanik ist der Bereich, den die moderne Schuhindustrie am meisten vernachlässigt. Konventionelle Schuhe machen die sechsundzwanzig Knochen, dreiunddreißig Gelenke und über hundert Muskeln des Fußes passiv. Dies führt zu Muskelschwäche und schlechterem Gleichgewicht. Das Barefoot-Design erzählt eine andere Geschichte. Zehen spreizen sich frei. Die Plantarfaszie nutzt ihre natürliche Federkraft. Propriozeptive Nerven werden aktiviert. Das Erden fügt dem eine weitere Dimension hinzu. Mit jedem Schritt balancieren elektrische Signale vom Boden das Nervensystem. Dieser Effekt erzeugt messbare Verbesserungen auch bei chronischen Schmerzpatienten. In meinen klinischen Beobachtungen berichteten Barefoot-Benutzer dreißig Prozent weniger Fußschmerzen im Vergleich zu Benutzern konventioneller Schuhe. Haltungs- und Gleichgewichtswerte verbesserten sich deutlich. Ihre Füße sind das Fundament Ihres Körpers. Geben Sie ihnen die verdiente Freiheit.',

    doctor3Name: 'Dr. Klaus Wagner',
    doctor3Title: 'Ganzheitliche Podologie | Berlin Medical Center',
    doctor3Quote: 'Die Wissenschaft bestätigt, was die Natur bereits wusste: Bodenkontakt heilt. Unsere klinischen Daten zeigen dies deutlich.',
    doctor3Narration: 'Ganzheitliche Medizin und moderne Wissenschaft gingen jahrelang getrennte Wege. Aber die Erdungsforschung bringt diese beiden Welten zusammen. Die Kosten des elektronischen Zeitalters sind hoch. Synthetische Böden, gummibeschichtete Schuhe und das Stadtleben trennen uns von der Erde. Positive elektrische Ladung sammelt sich in unserem Körper an. Diese elektrostatische Unausgeglichenheit breitet sich wie eine stille Epidemie aus. Schlafstörungen, chronische Müdigkeit, Schwächen des Immunsystems... Erdungsschuhe bieten für dieses Problem eine elegante Lösung. Kupferleitende Systeme ermöglichen den Fluss negativer Ionen in den Körper. Freie Radikale werden neutralisiert. In meinen klinischen Versuchen sanken die Kortisolspiegel bei Patienten, die zwölf Wochen lang Erdungsschuhe trugen, um achtundzwanzig Prozent. Die Schlafqualität verbesserte sich merklich. Entzündungsmarker nahmen signifikant ab. Organische Materialien, Kupferleiters, Barefoot-Design... Ihre Kombination ist kein Zufall. Dies ist die perfekte Zusammenarbeit von Wissenschaft und Natur.',
  },
  groundingAudio: {
    badge: 'Grounding-Philosophie',
    title: 'Spüren Sie die Energie der Erde',
    subtitle: 'Erleben Sie die Wissenschaft hinter Grounding-Barfußschuhen und die heilende Kraft der Natur durch Audio.',
    listenBtn: 'Jetzt Anhören',
    stopBtn: 'Stoppen',
    playingLabel: 'Wird abgespielt...',
    narration: 'Die Erde... ist die älteste und kraftvollste Energiequelle des menschlichen Körpers. Jahrtausende lang gingen Menschen barfuß, lebten im Kontakt mit der Natur. Doch das moderne Leben... hat diese natürliche Verbindung weitgehend durchtrennt. Genau an diesem Punkt kommt das Konzept des Groundings — oder Earthings — ins Spiel. Grounding-Barfußschuhe, Sandalen und Stiefel... sind darauf ausgelegt, eine direkte Energiebrücke zwischen Ihrem Fuß und der Erde herzustellen. Im Mittelpunkt dieses besonderen Designs steht Kupfer. Kupfer ist einer der kraftvollsten Leitmetalle der Natur. Dank seiner Fähigkeit, elektrische Ladungen zu transportieren... überträgt es die in Ihrem Körper angesammelte statische Elektrizität in die Erde und ermöglicht Ihnen, mit den natürlichen negativen Elektronen der Erde in Kontakt zu treten. Was passiert in diesem Prozess? Ihr Körper... beginnt, zu seinem natürlichen Gleichgewicht zurückzufinden. Mit dem Grounding-Effekt können Stress und Anspannung abnehmen, die Schlafqualität sich verbessern, Muskel- und Gelenkentspannung erreicht werden, die Durchblutung unterstützt werden und ein spürbarer Anstieg des Energieniveaus wahrgenommen werden. Das Barfuß-Design beschränkt sich nicht nur auf Energie. Dank der breiten Zehenbox spreizen sich Ihre Zehen auf natürliche Weise. Die dünne und flexible Sohle lässt Sie den Boden spüren. Ihr Fuß... bewegt sich so, wie er sollte. Denn der menschliche Fuß wurde nicht geschaffen, um unterstützt zu werden... sondern um auf natürliche Weise zu funktionieren. Die leitfähigen Kupferpunkte auf den Sohlen der Grounding-Schuhe berühren mit jedem Schritt die Erde und stellen eine ununterbrochene Verbindung zwischen Ihrem Körper und der Welt her. Das ist nicht nur ein Schuh... das ist ein Weg zurück zur Natur. Bei jedem Schritt... spüren Sie die Energie der Erde. Spüren Sie das Gleichgewicht. Spüren Sie die Natur. Verbinden Sie sich wieder mit Grounding-Barfußschuhen. Entdecken Sie die heilende Kraft des Groundings und des Barfußlaufens. Durch die Verbindung mit dem ständigen Strom wohiltätiger Elektronen von der Erdoberfläche unterstützt diese Verbindung die natürlichen Heilungs- und Regenerationsprozesse Ihres Körpers und fördert optimale Gesundheit und Wohlbefinden in Ihrem täglichen Leben.',
  },
  wholesalePage: {
    pageTitle: 'Großhandelsportal',
    pageSubtitle: 'FentyBarefoot Händler & Großhandelszentrum',
    heroBadge: 'Autorisiertes Händlerprogramm',
    heroTitle: 'Großhandelskatalog',
    heroDesc: 'Bestellen Sie unsere Grounding-Barfuß-Produkte im Großhandel. Sonderpreise gelten ab 50 Einheiten.',
    loginTitle: 'Händler-Login',
    loginSubtitle: 'Anmelden um Großhandelspreise zu sehen',
    loginUsername: 'Benutzername',
    loginPassword: 'Passwort',
    loginBtn: 'Anmelden',
    loginError: 'Ungültiger Benutzername oder Passwort',
    logoutBtn: 'Abmelden',
    loggedInAs: 'Angemeldet als:',
    priceHidden: 'Anmelden um Preis zu sehen',
    priceHiddenShort: 'Händler-Login erforderlich',
    unlockPrices: 'Als Händler anmelden um Preise zu sehen',
    requestBtn: 'Angebot anfragen',
    requestNote: 'Der Preis wird nach Menge festgelegt. Sie senden eine Angebotsanfrage.',
    requestModalTitle: 'Großhandels-Anforderungsformular',
    requestModalDesc: 'Senden Sie Ihre Großhandelsbestellung für das ausgewählte Produkt.',
    requestProduct: 'Produkt',
    requestQty: 'Menge',
    requestName: 'Vollständiger Name',
    requestEmail: 'E-Mail',
    requestPhone: 'Telefon',
    requestCompany: 'Firmenname',
    requestMessage: 'Notizen',
    requestSend: 'Anfrage senden',
    requestClose: 'Schließen',
    requestSuccess: 'Ihre Anfrage wurde gesendet! Wir werden uns in Kürze melden.',
    stockInfo: 'Lagerbestand',
    material: 'Material',
    sizes: 'Größen',
    colors: 'Farben',
    images: 'Bilder',
    priceTierTitle: 'Großhandelspreisstufen',
    priceTier50: '50+ Einheiten',
    priceTier100: '100+ Einheiten',
    priceTier500: '500+ Einheiten',
    sortBy: 'Sortieren',
    sortDefault: 'Standard',
    sortPriceLow: 'Preis: Niedrig bis Hoch',
    sortPriceHigh: 'Preis: Hoch bis Niedrig',
    noProducts: 'Keine Produkte für diesen Filter gefunden.',
    viewImages: 'Bild',
    of: 'von',
    totalProducts: 'Produkte',
    loginRequired: 'Händler-Login erforderlich für Großhandelspreise',
    loginRequiredDesc: 'Bitte melden Sie sich mit Ihrem Händlerkonto an.',
    dealerLoginBox: 'Händler-Anmeldefeld',
    headerTagline: 'Türkeis größtes Grounding Barefoot Großhandelszentrum',
    statsProducts: 'Produktvarianten',
    statsCountries: 'Länder-Händler',
    statsYears: 'Jahre Erfahrung',
    statsDealers: 'Aktive Händler',
  },

  footerNotif: {
    liveBadge: 'Live-Benachrichtigungen',
    paused: '⏸ Pausiert',
    liveStatus: '▶ Live',
    buyAction: 'hat gekauft',
    favAction: 'zu Favoriten hinzugefügt',
    cartStatAction: 'Personen haben im Warenkorb',
    favStatAction: 'Personen zu Favoriten hinzugefügt',
    labelBuy: 'Gekauft',
    labelFav: 'Favorisiert',
    labelCart: 'Im Warenkorb',
    labelLive: 'Live',
    justNow: 'Gerade eben',
    min1: 'vor 1 Min',
    min2: 'vor 2 Min',
    min3: 'vor 3 Min',
    min5: 'vor 5 Min',
    min7: 'vor 7 Min',
    prod1: 'Goldene Flechtensandalen',
    prod2: 'Leder-Pantoletten',
    prod3: 'Boho-Maxikleid',
    prod4: 'Absatzige Riemchensandalen',
    prod5: 'Leinenwickelkleid',
    prod6: 'Plateausandalen',
    prod7: 'Vegane Lederpantoffeln',
    prod8: 'Florales Midi-Kleid',
    prod9: 'Herren-Sandalen',
    prod10: 'Herren-Leinenhemd',
    prod11: 'Flache Strohsandalen',
    prod12: 'Kordsandalen',
    prod13: 'Absatzige Pantoletten',
    prod14: 'Gold-Armband-Set',
    prod15: 'Sommer-Kombi-Set',
    prod16: 'Herren-Sommer-Kombi',
    prod17: 'Ledertasche + Sandalen',
    prod18: 'Boho-Tasche + Pantoffeln',
    prod19: 'Sommerkleid-Kombi',
    prod20: 'Strand-Set',
    prod21: 'Buntes Bikini-Set',
    prod22: 'Stroh-Strandtasche',
    prod23: 'Sonnenbrille',
    prod24: 'Baumwoll-Sommerkleid',
    prod25: 'Ledergürtel',
    prod26: 'Geflochtene Sandalen',
    prod27: 'Geblümte Bluse',
    prod28: 'Leinenshorts',
    prod29: 'Silberkette',
    prod30: 'Rattantasche',
  },

  memberPanel: {
    breadcrumbHome: 'Startseite',
    breadcrumbPanel: 'Mein Konto',
    loading: 'Lädt...',
    memberSince: 'Mitglied seit:',
    menu: 'Menü',
    logout: 'Abmelden',
    logoutConfirmTitle: 'Möchten Sie sich abmelden?',
    logoutConfirmDesc: 'Sie werden sicher aus Ihrem Konto abgemeldet.',
    logoutCancel: 'Abbrechen',
    tabOrders: 'Meine Bestellungen',
    tabReturns: 'Meine Rückgaben',
    tabCoupons: 'Meine Rabattgutscheine',
    tabSupport: 'Meine Support-Tickets',
    tabInvoices: 'Meine Rechnungen',
    ordersTitle: 'Meine Bestellungen',
    ordersCount: '{{count}} Bestellungen gefunden',
    statusDelivered: 'Geliefert',
    statusShipped: 'Versandt',
    statusProcessing: 'In Bearbeitung',
    statusCancelled: 'Storniert',
    qty: 'Menge:',
    deliveryInfo: 'Lieferinformationen',
    paymentInfo: 'Zahlungsinformationen',
    addressLabel: 'Adresse:',
    trackingLabel: 'Sendungsnr.:',
    methodLabel: 'Methode:',
    totalLabel: 'Gesamt:',
    actionCancel: 'Bestellung stornieren',
    actionReturn: 'Rückgabe',
    actionExchange: 'Umtausch anfragen',
    actionInvoice: 'Rechnung ansehen',
    actionTrack: 'Sendung verfolgen',
    modalCancelTitle: 'Bestellstornierung',
    modalReturnTitle: 'Rückgabeantrag',
    modalExchangeTitle: 'Umtauschantrag',
    modalOrderLabel: 'Bestellung:',
    reasonLabel: 'Grund',
    reasonPlaceholder: 'Grund auswählen...',
    descriptionLabel: 'Beschreibung',
    descriptionOptional: '(optional)',
    descriptionPlaceholder: 'Sie können weitere Informationen hinzufügen...',
    submitCancelBtn: 'Stornierungsantrag senden',
    submitReturnBtn: 'Rückgabeantrag senden',
    submitExchangeBtn: 'Umtauschantrag senden',
    dismiss: 'Abbrechen',
    requestReceived: 'Antrag erhalten!',
    requestReceivedDesc: 'Ihr Antrag für die Bestellung wurde übermittelt. Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.',
    ok: 'OK',
    cancelReason1: 'Ich möchte das Produkt nicht mehr',
    cancelReason2: 'Ich habe das falsche Produkt bestellt',
    cancelReason3: 'Preisänderung',
    cancelReason4: 'Lieferzeit ist zu lang',
    returnReason1: 'Produkt hat meine Erwartungen nicht erfüllt',
    returnReason2: 'Beschädigtes / defektes Produkt',
    returnReason3: 'Falsches Produkt wurde gesendet',
    returnReason4: 'Produkt entspricht nicht der Beschreibung',
    exchangeReason1: 'Größentausch',
    exchangeReason2: 'Farbtausch',
    exchangeReason3: 'Austausch gegen ein anderes Produkt',
    exchangeReason4: 'Beschädigtes Produkt — Umtausch',
    returnsTitle: 'Meine Rückgaben',
    returnsCount: '{{count}} Anträge gefunden',
    returnStatusPending: 'Ausstehend',
    returnStatusApproved: 'Genehmigt',
    returnStatusCompleted: 'Abgeschlossen',
    returnStatusRejected: 'Abgelehnt',
    typeReturn: 'Rückgabe',
    typeExchange: 'Umtausch',
    orderLabel: 'Bestellung:',
    requestDateLabel: 'Antragsdatum:',
    reasonColLabel: 'Grund:',
    refundAmount: 'Erstattungsbetrag',
    refundMethod: 'Erstattungsmethode',
    estimatedRefundDate: 'Voraussichtliches Erstattungsdatum',
    pendingInfo: 'Ihr Antrag wird bearbeitet. Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.',
    noReturns: 'Noch keine Rückgabeanträge',
    noReturnsDesc: 'Sie können Rückgabe- / Umtauschanträge im Bereich Meine Bestellungen stellen.',
    returnsPolicyTitle: 'Rückgabe- & Umtauschrichtlinie',
    returnsPolicyDesc: 'Sie können unbenutzte Produkte innerhalb von 30 Tagen nach Lieferung kostenlos zurückgeben. Rücksendekosten werden von uns übernommen.',
    couponsTitle: 'Meine Rabattgutscheine',
    activeCouponsCount: '{{count}} aktive Gutscheine',
    used: 'Verwendet',
    copy: 'Kopieren',
    copied: 'Kopiert',
    activeCoupons: 'Aktive Gutscheine',
    usedCoupons: 'Verwendete Gutscheine',
    minOrderLabel: 'Min.',
    validUntilLabel: 'Bis:',
    couponPlaceholder: 'CODE EINGEBEN',
    apply: 'Anwenden',
    applied: 'Angewendet',
    couponApplied: '10% Rabatt angewendet!',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    free: 'Kostenlos',
    discount: 'Rabatt',
    total: 'Gesamt',
    vatIncluded: 'MwSt. inklusive',
    sslSecure: 'SSL Sicher',
    easyReturn: 'Einfache Rückgabe',
    errFirstName: 'Vorname ist erforderlich',
    errLastName: 'Nachname ist erforderlich',
    errEmail: 'E-Mail ist erforderlich',
    errEmailInvalid: 'Gültige E-Mail eingeben',
    errPhone: 'Telefon ist erforderlich',
    errAddress: 'Adresse ist erforderlich',
    errCity: 'Stadt ist erforderlich',
    errPostalCode: 'Postleitzahl ist erforderlich',
    errCardName: 'Kartenname ist erforderlich',
    errCardNumber: 'Gültige Kartennummer eingeben',
    errCardExpiry: 'Ablaufdatum ist erforderlich',
    errCardCvv: 'CVV ist erforderlich',
    errTerms: 'Sie müssen die Nutzungsbedingungen akzeptieren',
    errCoupon: 'Ungültiger Gutscheincode',
    errCouponMinOrder: 'Mindestbestellwert für diesen Gutschein ist {{amount}}',
    successTitle: 'Bestellung erhalten! 🎉',
    successSubtitle: 'Danke! Ihre Bestellung wurde erfolgreich erstellt und wird vorbereitet.',
    orderNumberLabel: 'Ihre Bestellnummer',
    orderNumberNote: 'Notieren Sie diese Nummer, Sie können sie zur Bestellverfolgung verwenden.',
    estimatedDelivery: 'Voraussichtliche Lieferung',
    businessDays: 'Werktage',
    paymentLabel: 'Zahlung',
    confirmEmail: 'Bestätigungs-E-Mail',
    confirmEmailSent: 'Gesendet',
    orderDetails: 'Bestelldetails',
    deliveryAddress: 'Lieferadresse',
    orderProcess: 'Bestellprozess',
    stepReceived: 'Bestellung erhalten',
    stepPreparing: 'Wird vorbereitet',
    stepShipped: 'Versandt',
    stepDelivered: 'Geliefert',
    backHome: 'Zurück zur Startseite',
    continueShopping: 'Weiter einkaufen',
    contactUs: 'Kundendienst',
    contactNote: 'Bei Fragen wenden Sie sich an unseren',
    contactEnd: '.',
    paymentCreditCard: 'Kreditkarte',
    paymentTransfer: 'Banküberweisung',
    footerTagline: 'Garantie für sicheres Einkaufen',
    footerContact: 'Kontakt',
    footerShipping: 'Versandinfo',
    footerReturns: 'Rückgaberichtlinie',
    footerSsl: '256-Bit-SSL Sichere Zahlung',
  },

  checkout: {
    breadcrumbHome: 'Startseite',
    breadcrumbCheckout: 'Kasse',
    pageTitle: 'Sicherer Checkout',
    pageSubtitle: 'Alle Ihre Informationen sind mit SSL geschützt',
    ssl: '256-bit SSL',
    secure3d: '3D Secure',
    pciDss: 'PCI DSS',
    customerTitle: 'Kundeninformationen',
    guestContinue: 'Als Gast fortfahren',
    memberLogin: 'Mitgliederanmeldung',
    guestInfo: 'Sie können als Gast bestellen.',
    register: 'Registrieren',
    firstName: 'Vorname',
    firstNamePlaceholder: 'Ihr Vorname',
    lastName: 'Nachname',
    lastNamePlaceholder: 'Ihr Nachname',
    email: 'E-Mail',
    emailPlaceholder: 'beispiel@email.com',
    phone: 'Telefon',
    phonePlaceholder: '+49 5XX XXX XX XX',
    password: 'Passwort',
    passwordPlaceholder: '••••••••',
    loginButton: 'Anmelden',
    noAccount: 'Haben Sie bereits ein Konto?',
    signUp: 'Registrieren',
    orContinueWith: 'oder weiter mit',
    google: 'Mit Google anmelden',
    welcome: 'Willkommen zurück!',
    subtitle: 'Melde dich an, um weiter einzukaufen',
    termsNote: 'Durch die Anmeldung akzeptieren Sie unsere',
    termsLink: 'Nutzungsbedingungen',
    termsAnd: 'und',
    privacyLink: 'Datenschutzrichtlinie',
    termsEnd: '.',
  },

  login: {
    title: 'Anmelden',
    email: 'E-Mail',
    emailPlaceholder: 'beispiel@email.com',
    password: 'Passwort',
    passwordPlaceholder: 'Passwort eingeben',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen',
    loginButton: 'Anmelden',
    noAccount: 'Haben Sie bereits ein Konto?',
    signUp: 'Registrieren',
    orContinueWith: 'oder weiter mit',
    google: 'Mit Google anmelden',
    welcome: 'Willkommen zurück!',
    subtitle: 'Melde dich an, um weiter einzukaufen',
    termsNote: 'Durch die Anmeldung akzeptieren Sie unsere',
    termsLink: 'Nutzungsbedingungen',
    termsAnd: 'und',
    privacyLink: 'Datenschutzrichtlinie',
    termsEnd: '.',
  },

  register: {
    title: 'Registrieren',
    name: 'Vollständiger Name',
    namePlaceholder: 'Ihr vollständiger Name',
    email: 'E-Mail',
    emailPlaceholder: 'beispiel@email.com',
    password: 'Passwort',
    passwordPlaceholder: 'Starkes Passwort erstellen',
    confirmPassword: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort erneut eingeben',
    terms: 'Ich akzeptiere die Nutzungsbedingungen',
    registerButton: 'Registrieren',
    haveAccount: 'Haben Sie bereits ein Konto?',
    login: 'Anmelden',
    discount: '10% Rabatt für neue Mitglieder!',
    passwordStrength: {
      weak: 'Schwach',
      medium: 'Mittel',
      strong: 'Stark',
    },
    sslNote: 'Ihre Daten sind sicher mit SSL geschützt',
  },

  story: {
    swipeHint: 'Wischen',
    productTaggedLabel: 'Produkte markiert — tippen zum Entdecken',
    goToProduct: 'Zum Produkt',
    discountLabel: 'Rabatt',
    followInstagram: 'Auf Instagram folgen • @fentybarefoot',
    stories: {
      s1: { title: '🔥 Bestseller', subtitle: 'Die Superstars der Woche sind hier — nicht verpassen!', badge: 'TOP SELLER', cta: 'Beliebte Produkte' },
      s2: { title: '✨ 2026 Neue Saison Sandalen', subtitle: 'Die neue handgefertigte Kollektion ist da', badge: 'NEUE SAISON 2026', cta: 'Damen Sandalen' },
      s3: { title: '👗 Damenkollektion', subtitle: 'Eleganz und Freiheit vereint', badge: 'KOLLEKTION', cta: 'Damenmode' },
      s4: { title: '🎉 Super Sale', subtitle: 'Bis zu 70% Rabatt — Bestände werden knapp!', badge: '70% RABATT', cta: 'Angebote entdecken' },
      s5: { title: '👟 Herrenkollektion', subtitle: 'Moderner Herrenstil — natürlich und bequem', badge: 'HERREN', cta: 'Herrenprodukte' },
      s6: { title: '🌿 Nachhaltige Mode', subtitle: 'Umweltfreundliche Produktion, luxuriöses Gefühl', badge: 'ÖKO', cta: 'Unsere Geschichte' },
      s7: { title: '👜 Accessoires & Taschen', subtitle: 'Details, die deinen Style vervollständigen', badge: 'NEU', cta: 'Accessoire-Kollektion' },
      s8: { title: '🎁 Kombi-Sets', subtitle: 'Zusammen günstiger — Sonderpreissets', badge: 'KOMBI-DEAL', cta: 'Sets entdecken' },
      s9: { title: '📸 Wir auf Instagram', subtitle: '@fentybarefoot — Tritt unserer Community bei', badge: 'SOCIAL', cta: 'Auf Instagram folgen' },
    },
  },

  fitGuide: {
    title: 'Passform-Leitfaden',
    subtitle: 'Wählen Sie, um die beste Passform für Sie zu finden',
    infoNote: 'Im Zweifelsfall empfehlen wir',
    infoHighlight: 'Weite Passform',
    infoNoteEnd: '— sitzt frei am Körper und passt zu jedem.',
    wideLabel: 'Weite Passform',
    wideFit: 'Komfortabel & Freie Bewegung',
    wideDesc: 'Ein atmungsaktiver Schnitt, der frei am Körper sitzt. Ideal für den täglichen Gebrauch und lange Tage.',
    wideFeature1: 'Extra Platz im Schulter- und Armbereich',
    wideFeature2: 'Lockere Taille, nicht einengend',
    wideFeature3: 'Bleibt stundenlang bequem',
    wideFeature4: 'Schränkt die Bewegung nicht ein',
    wideFeature5: 'Passt zu jedem Körpertyp',
    wideBest: 'Alltag, Reisen, lockere Kleidung',
    narrowLabel: 'Enge Passform',
    narrowFit: 'Körpernah & Schicke Silhouette',
    narrowDesc: 'Ein strukturierter, körperbetonter Schnitt, der Ihre Figur unterstreicht. Perfekt für besondere Anlässe.',
    narrowFeature1: 'Sitzt eng an Schultern und Brust',
    narrowFeature2: 'Perfekte Passform für schmale Füße',
    narrowFeature3: 'Elegantes und gepflegtes Aussehen',
    narrowFeature4: 'Ideal für besondere Anlässe',
    narrowFeature5: 'Bietet eine schlanke und raffinierte Silhouette',
    narrowBest: 'Besondere Anlässe, formelle Events',
    compareTitle: 'Sohlenvergleich',
    featureHeader: 'Merkmal',
    compareWide: 'Weite Passform',
    compareNarrow: 'Enge Passform',
    row1Label: 'Komfort', row1Wide: '⭐⭐⭐⭐⭐', row1Narrow: '⭐⭐⭐⭐',
    row2Label: 'Silhouette', row2Wide: 'Fließend & Frei', row2Narrow: 'Definiert & Körpernah',
    row3Label: 'Bewegungsfreiheit', row3Wide: 'Maximum', row3Narrow: 'Moderat',
    row4Label: 'Beste Verwendung', row4Wide: 'Alltag & Casual', row4Narrow: 'Besondere & Formelle Anlässe',
    row5Label: 'Körperanpassung', row5Wide: 'Alle Typen, breite Basis', row5Narrow: 'Je nach Präferenz',
    bestLabel: 'Am besten für:',
    liveSupportText: 'Nicht sicher, welche Passform die richtige ist?',
    liveSupportLink: 'Live-Support',
    liveSupportEnd: 'Team hilft gerne weiter.',
    shoe: {
      title: 'Schuh-Leisten-Ratgeber',
      subtitle: 'Wählen Sie die richtige Passform nach Zehenbreite',
      infoNote: 'Unsere Barefoot-Schuhe haben einen',
      infoHighlight: 'anatomischen Leisten',
      infoNoteEnd: '— Zehen spreizen sich natürlich ohne Druck.',
      barefootLabel: 'Barefoot-Leisten',
      barefootTagline: 'Anatomisch & Weite Zehenbox',
      barefootDesc: 'Breite Zehenbox, anatomische Passform. Zehen bewegen sich frei ohne Einengung.',
      barefootF1: 'Breiteste Zehenbox verfügbar',
      barefootF2: 'Zehen spreizen sich natürlich',
      barefootF3: 'Maximaler Komfort den ganzen Tag',
      barefootF4: 'Unterstützt natürliche Fußhaltung',
      barefootBest: 'Alltag, Reisen, gesundes Leben',
      standartLabel: 'Standard-Leisten',
      standartTagline: 'Normal & Ausgeglichene Passform',
      standartDesc: 'Klassischer ausgewogener Schnitt mit mittlerer Zehenbox — für die meisten Fußtypen.',
      standartF1: 'Mittlere Zehenbox-Breite',
      standartF2: 'Passt vielen Fußformen',
      standartF3: 'Schlankes und vielseitiges Aussehen',
      standartF4: 'Ideal für leicht schmalere Füße',
      standartBest: 'Alltag, Arbeit, Freizeit',
      darLabel: 'Schmal Standard',
      darTagline: 'Schmal & Elegante Silhouette',
      darDesc: 'Schmale Zehenbox, anliegender Schnitt — speziell für schlanke, lange Füße.',
      darF1: 'Schmalste Zehenbox',
      darF2: 'Perfekte Passform für schmale Füße',
      darF3: 'Elegantes und gepflegtes Aussehen',
      darF4: 'Ideal für besondere Anlässe',
      darBest: 'Besondere Anlässe, formelle Events',
      toeGenis: 'Zehen: Weit',
      toeNormal: 'Zehen: Normal',
      toeDar: 'Zehen: Schmal',
      compareTitle: 'Sohlenvergleich',
      cmpToe: 'Zehenbox',
      cmpToeBarefoot: 'Sehr Weit',
      cmpToeStandart: 'Mittel',
      cmpToeDar: 'Schmal',
      cmpConfort: 'Komfort',
      cmpUse: 'Verwendung',
      cmpUseBarefoot: 'Alltag & Aktiv',
      cmpUseStandart: 'Alltag & Schick',
      cmpUseDar: 'Besondere & Formelle Anlässe',
      cmpFit: 'Fußtyp',
      cmpFitBarefoot: 'Alle Typen, breite Basis',
      cmpFitStandart: 'Standardfuß',
      cmpFitDar: 'Schlanker & langer Fuß',
    },
  },

  careGuide: {
    tabDescription: 'Produktbeschreibung',
    tabMaterial: 'Stoff-Info',
    tabCare: 'Pflegehinweise',
    tabLeather: 'Lederpflege',
    tabSole: 'Sohlenmerkmale',
    compositionTitle: 'Materialzusammensetzung',
    mainFabricLabel: 'Hauptstoff',
    mainFabricVal: '100% Bio-Leinen',
    liningLabel: 'Futter',
    liningVal: '100% Bio-Baumwolle',
    certLabel: 'Zertifizierung',
    certVal: 'GOTS Zertifiziert Bio',
    propertiesTitle: 'Stoffeigenschaften',
    prop1: 'Atmungsaktive und leichte Struktur',
    prop2: 'Feuchtigkeitsableitende Eigenschaften',
    prop3: 'Natürliche Garnstruktur, hypoallergen',
    prop4: 'UV-beständig, langlebig',
    prop5: 'Umweltfreundlich, natürlich gewonnen',
    washLabel: 'Waschen',
    washVal: '30°C Schonwäsche',
    washNote: 'In kaltem Wasser im Schonwaschgang waschen',
    dryLabel: 'Trocknen',
    dryVal: 'Lufttrocknen',
    dryNote: 'Im Schatten, natürlicher Umgebung trocknen',
    ironLabel: 'Bügeln',
    ironVal: 'Mittlere Hitze ••',
    ironNote: 'Feuchtes Tuch oder Dampfbügeleisen verwenden',
    bleachLabel: 'Bleichen',
    bleachVal: 'Chlorfrei',
    bleachNote: 'Mildes, sauerstoffbasiertes Waschmittel verwenden',
    dryCleanLabel: 'Chemisch Reinigen',
    dryCleanVal: 'Nicht Empfohlen',
    dryCleanNote: 'Keine chemische Reinigung',
    tipsTitle: 'Expertenpflegetipps',
    tip1: 'Beim ersten Waschen kann leichtes Ausbluten auftreten — getrennt waschen',
    tip2: 'Leichte Faltenbildung bei Leinen ist normal — dampfbügeln',
    tip3: 'Dunkle Farben auf links waschen',
    tip4: 'Nicht im Trockner trocknen — Form kann sich verziehen',
    orgCertNote: 'Was ist GOTS-Zertifizierung?',
    orgCertDesc: 'Global Organic Textile Standard — der strengste Bio-Standard der Textilindustrie, der den gesamten Produktionsprozess abdeckt.',
    // Lederpflege
    leatherWarningTitle: 'Ledersohle Warnung',
    leatherWarningText: 'Ledersohlen sind nicht für übermäßige Feuchtigkeit geeignet. Längerer Kontakt mit Regen, Pfützen oder nassen Oberflächen kann das Leder beschädigen.',
    rubberTitleSection: 'Gummisohle — Sicher bei Jedem Wetter',
    rubberDesc: 'Gummisohlen sind wasser-, winter- und kältebeständig und bieten ausgezeichneten Grip auf nassen, kalten und harten Oberflächen.',
    leatherCare1Label: 'Feuchtigkeit',
    leatherCare1Val: 'Schützen',
    leatherCare1Note: 'Von Regen und Wasser fernhalten',
    leatherCare2Label: 'Reinigung',
    leatherCare2Val: 'Feuchtes Tuch',
    leatherCare2Note: 'Keine starken Reinigungsmittel',
    leatherCare3Label: 'Lagerung',
    leatherCare3Val: 'Belüftet',
    leatherCare3Note: 'Von direktem Sonnenlicht fernhalten',
    leatherCare4Label: 'Konditionierer',
    leatherCare4Val: 'Empfohlen',
    leatherCare4Note: 'Lederpflegecreme verwenden',
    leatherCare5Label: 'Trocknung',
    leatherCare5Val: 'Lufttrocknen',
    leatherCare5Note: 'Keine Wärme oder Fön',
    leatherTipsTitle: 'Lederpflegetipps',
    leatherTip1: 'Nasses Leder niemals direkter Wärme aussetzen — im Schatten natürlich trocknen lassen',
    leatherTip2: 'Einmal im Monat Lederpflegecreme oder natürliches Öl auftragen',
    leatherTip3: 'In einem Staubbeutel aufbewahren, wenn nicht in Gebrauch',
    leatherTip4: 'Flecken sofort mit feuchtem Tuch abwischen',
    // Sohlenmerkmale
    soleFeature1Title: 'Ledersohle',
    soleFeature1Badge: 'Klassisch & Natürlich',
    soleFeature1Desc: 'Handgefertigte echte Ledersohle — atmungsaktiv, formt sich dem Fuß an und entwickelt Charakter.',
    soleFeature1Pro1: 'Atmungsaktiv und natürliches Gefühl',
    soleFeature1Pro2: 'Passt sich der Fußform an',
    soleFeature1Pro3: 'Elegantes Erscheinungsbild',
    soleFeature1Con1: 'Übermäßiger Feuchtigkeit vermeiden',
    soleFeature2Title: 'Gummisohle',
    soleFeature2Badge: 'Langlebig & Allwetter',
    soleFeature2Desc: 'Gummisohlen sind wasser-, winter- und kältebeständig und bieten ausgezeichneten Grip auf nassen, kalten und harten Oberflächen.',
    soleFeature2Pro1: 'Wasser- und winterbeständig',
    soleFeature2Pro2: 'Rutschsicherheit auf harten Flächen',
    soleFeature2Pro3: 'Für alle vier Jahreszeiten geeignet',
    soleFeature3Title: 'Kupfer + Erdung',
    soleFeature3Badge: 'Erdungseffekt',
    soleFeature3Desc: 'Leitfähige Kupferdetails ermöglichen bei jedem Schritt eine Erdungsverbindung mit der Erde.',
    soleFeature3Pro1: 'Wissenschaftlicher Erdungseffekt',
    soleFeature3Pro2: 'Energie der Erde spüren',
    soleFeature3Pro3: 'Trägt zur Stressreduktion bei',
    soleCompareTitle: 'Sohlenvergleich',
    soleCompareName: 'Merkmal',
    soleCompareWater: 'Wasserbeständigkeit',
    soleCompareWinter: 'Winterleistung',
    soleCompareGrip: 'Griffigkeit',
    soleCompareBreath: 'Atmungsaktivität',
  },

  productFAQ: {
    badge: 'Produkt FAQ',
    title: 'Häufig Gestellte Fragen',
    subtitle: 'Die häufigsten Fragen zu diesem Produkt',
    q1: 'Wie finde ich meine Größe?',
    a1: 'Wir empfehlen unsere Größentabelle zu verwenden. Wenn Sie zwischen zwei Größen liegen, wählen Sie die größere — kostenlose Rückgabe und Umtausch sind verfügbar.',
    q2: 'Welche Materialien werden verwendet?',
    a2: 'Unsere Produkte werden aus GOTS-zertifiziertem Bio-Leinen und Baumwolle hergestellt. Keine chemischen Farbstoffe — alle Materialien sind natürlich und nachhaltig.',
    q3: 'Wann wird meine Bestellung ankommen?',
    a3: 'Ihre Bestellung wird innerhalb von 1-2 Werktagen vorbereitet. Lieferung in der Türkei 3-5 Werktage, international 6-12 Werktage. Kostenloser Versand gilt.',
    q4: 'Kann ich das Produkt zurückgeben?',
    a4: 'Ja! Innerhalb von 30 Tagen nach Erhalt kostenlos zurücksenden. Rücksendekosten werden von uns übernommen. Unbenutzt, mit intakten Etiketten und Originalverpackung.',
    q5: 'Welche Sohle soll ich wählen?',
    a5: 'Für täglichen und sommerlichen Gebrauch ist die Ledersohle eine elegante, natürliche Wahl. Für Regen, Winter oder raues Gelände ist die Gummisohle langlebiger. Für Erdung wählen Sie Kupfer + Erdung.',
    q6: 'Weite oder schmale Passform?',
    a6: 'Im Zweifelsfall empfehlen wir weite Passform — sitzt frei am Körper, passt zu jeder Figur und bleibt den ganzen Tag bequem. Enge Passform für eine definiertere Silhouette.',
    q7: 'Wie pflege ich das Produkt?',
    a7: 'Maschinenwäsche im Schongang bei 30°C. Leichte Faltenbildung ist bei Leinen normal — Dampfbügeln. Chlorfreies Waschmittel verwenden und an der Luft trocknen.',
    q8: 'Kann ich die Bestellung personalisieren?',
    a8: 'Absolut! Sie können einen benutzerdefinierten Namen, eine Nachricht oder eine Farbpräferenz hinzufügen. Geschenkverpackungsoptionen sind ebenfalls verfügbar.',
    ctaTitle: 'Haben Sie weitere Fragen?',
    ctaDesc: 'Unser Live-Support-Team ist 24/7 bereit zu helfen.',
    ctaBtn: 'Live-Support',
  },
  relatedProducts: {
    title: 'Ähnliche Produkte',
    subtitle: 'Alternativen aus derselben Kategorie, die dir gefallen könnten',
    freeShipping: 'Kostenlos',
    sold: 'verkauft',
    viewProduct: 'Produkt ansehen',
    viewAll: 'Alle Produkte ansehen',
  },
  alsoBought: {
    title: 'Kunden kauften auch',
    subtitle: 'Die beliebtesten Produkte von Kunden, die dieses Produkt gekauft haben',
    liveBadge: 'Gerade im Trend',
    trending: 'Trend',
    soldTogether: 'Personen kauften zusammen',
    quickView: 'Schnellansicht',
    quickViewLabel: 'Schnelle Vorschau',
    added: 'Hinzugefügt',
    trustSecure: 'Sicheres Bezahlen',
    trustShipping: 'Kostenloser Versand',
    trustReturn: '30 Tage Rückgabe',
    qvDiscount: 'Rabatt',
    qvSave: 'Sparen',
    qvReviews: 'Bewertungen',
    qvAddToCart: 'In den Warenkorb',
    qvGoToProduct: 'Zur Produktseite',
    qvNote: 'Besuchen Sie die Produktseite für alle Optionen und Details.',
  },
  igPopup: {
    title: '🎉 60% Rabatt sichern',
    description: 'Folge uns auf Instagram, like 3 Beiträge, kommentiere 3 Beiträge und schreib uns "CODE" per DM!',
    step1: 'Folge uns: @zenciv.store',
    step2: '3 Beiträge liken',
    step3: '3 Beiträge kommentieren',
    step4: '"CODE" per DM senden',
    usernamePlaceholder: 'Dein Instagram-Benutzername',
    emailPlaceholder: 'Deine E-Mail-Adresse',
    goToInstagram: 'Zu Instagram gehen',
    completed: 'Erledigt – DM senden',
    sending: 'Wird gesendet...',
    trustNote: 'Kein Spam. Nur Rabatte & Updates.',
    errorInstagram: 'Instagram-Benutzername ist erforderlich.',
    errorEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    successTitle: 'Super, danke!',
    successText: 'Sobald wir deine Aktivität bestätigt haben, senden wir dir deinen 60%-Rabattcode per DM.',
    successDiscount: '60% Rabattcode kommt per DM',
    sendDM: 'DM senden',
    continueShopping: 'Weiter einkaufen',
    neverShow: 'Nicht mehr anzeigen',
  },
  measureGuide: {
    btnLabel: 'Messanleitung',
    title: 'Fußmessanleitung',
    subtitle: 'Barfußmessung — in cm',
    diagramLabel: 'Messdiagramm',
    lengthLabel: 'LÄNGE',
    widthLabel: 'BREITE',
    toeWidthLabel: 'ZEHENBREITE',
    example: 'Beispiel:',
    stepsTitle: 'Wie messen?',
    step1Title: 'Weißes Papier hinlegen',
    step1Desc: 'Legen Sie ein weißes Blatt Papier auf eine ebene Fläche. Ziehen Sie Ihre Socken aus und stellen Sie sich auf das Papier.',
    step2Title: 'Fuß umreißen',
    step2Desc: 'Halten Sie den Stift aufrecht und umreißen Sie Ihren Fuß sorgfältig. Einschließlich Ferse und längstem Zeh.',
    step3Title: 'Länge messen',
    step3Desc: 'Messen Sie den Abstand von der Ferse bis zur Spitze des längsten Zehs in Zentimetern.',
    step4Title: 'Breite messen',
    step4Desc: 'Messen Sie an der breitesten Stelle des Fußes (im Bereich des Zehengrundgelenks).',
    tipLabel: 'Tipp:',
    tip: 'Wenn Ihre Füße unterschiedliche Größen haben, nehmen Sie den größeren. Geben Sie Ihre Messung im Personalisierungsfeld im Format "24,5 CM × 9 CM" ein.',
    gotIt: 'Verstanden, Schließen',
  },

  barefootHealth: {
    badgeLabel: 'Podiatrisch Zertifiziert',
    verified: 'Wissenschaftliche Forschung',
    title: 'Gesundheitsvorteile von Barefoot',
    subtitle: 'Von Podiatristen empfohlene Barefoot-Technologie — die natürlichste Wahl für Ihre Füße.',
    more: 'mehr',
    cta: 'Alle Gesundheitsvorteile Sehen',
    popupTitle: 'Gesundheitsvorteile der Barefoot-Technologie',
    popupSubtitle: 'Wissenschaft trifft Natur — bewährte Vorteile für Ihre Fußgesundheit',
    podiatrist: 'Podologe & Fußgesundheitsspezialist',
    benefitsTitle: '6 Kerngesundheitsvorteile',
    benefits: [
      'Natürliches Zehenbreiten',
      'Verbesserte Balance & Koordination',
      'Muskelkräftigung',
      'Gelenkgesundheit',
      'Natürliche Ganghaltung',
      'Bodenanpassung',
    ],
    benefitDescs: [
      'Die breite Zehenbox lässt die Zehen in ihrer anatomischen Position natürlich spreizen.',
      'Die Minimalsohle erhöht die Propriozeption und verbessert Balance und Koordination.',
      'Fuß-, Waden- und Hüftmuskeln arbeiten natürlicher und werden mit der Zeit stärker.',
      'Reduzierter Gelenkdruck unterstützt langfristige Knie- und Hüftgesundheit.',
      'Fersenaufprall wird reduziert, natürlicher Vorfußgang wird unterstützt.',
      'Das Bodengefühl nimmt zu und entwickelt die Gehirn-Fuß-Verbindung.',
    ],
    doctorQuote: 'Barefoot-Schuhe sind eine der anatomisch geeignetsten Optionen für den Fuß. Die breite Zehenbox lässt Zehen natürlich spreizen, während die Minimalsohle die Propriozeption verbessert. Langfristig kann dies helfen, Hallux valgus, Hammerzehen und Plantarfasziitis zu verhindern.',
    warningsTitle: 'Risiken von herkömmlichem Schuhwerk',
    warnings: [
      'Zehenkompression kann zu Hallux valgus und Hammerzehen führen',
      'Hohe Absätze stören den Körperschwerpunkt',
      'Übermäßige Unterstützung schwächt Fußmuskeln',
      'Schmale Zehenbox kann Nervenkompression verursachen',
      'Dicke Sohlen blockieren Bodensensorik',
      'Langfristige Gangstörungen können sich entwickeln',
    ],
    anatomyTitle: 'Barefoot vs. Traditionell: Anatomischer Vergleich',
    anatomyBarefoot: 'Barefoot — natürlich & gesund',
    anatomyTraditional: 'Traditionell — Kompression & Druck',
  },

  groundingSole: {
    headerTitle: 'Kupfer + Erdungs-Sohle',
    headerSubtitle: 'Energieverbindung mit der Natur bei jedem Schritt',
    scienceBadge: 'Wissenschaftlicher Beweis',
    diagramFoot: 'Fuß',
    diagramCopper: 'Kupferdraht',
    diagramIons: 'Negative Ionen',
    diagramSole: 'Kupfersohle',
    diagramEarth: 'Erdverbindung',
    howItWorks: 'Wie funktioniert es?',
    step1Title: 'Kupfer-Leitfähigkeit',
    step1Desc: 'Dünne Kupferfäden in der Sohle verbinden Ihren Fuß direkt mit dem elektromagnetischen Feld der Erde. Kupfer ist einer der besten natürlichen Leiter.',
    step2Title: 'Bodenkontakt',
    step2Desc: 'Wenn die Sohle beim Gehen den Boden berührt, beginnt der freie Elektronenfluss — das wissenschaftliche Äquivalent zum Barfußlaufen auf natürlichem Boden.',
    step3Title: 'Negativer Ionenfluss',
    step3Desc: 'Negative Ionen, die vom Boden in den Körper gelangen, neutralisieren freie Radikale, reduzieren Entzündungen und unterstützen die Zellenergie.',
    benefitsTitle: 'Gesundheitsvorteile',
    benefit1: 'Reduziert Entzündungen',
    benefit2: 'Verbessert die Schlafqualität',
    benefit3: 'Neutralisierung freier Radikale',
    benefit4: 'Senkt Stress & Kortisol',
    benefit5: 'Verbessert die Durchblutung',
    benefit6: 'Unterstützung des Immunsystems',
    stat1: 'Wissenschaftliche Studien',
    stat2: 'Zufriedene Nutzer',
    stat3: 'Spürten einen Unterschied',
    quoteText: 'Erdung stabilisiert den Körper elektrisch. Ich betrachte es als natürliche Intervention gegen chronische Entzündungen, Stress und Schlafprobleme.',
    quoteAuthor: 'Dr. Klaus Weber',
    quoteRole: 'Podologe & Fußgesundheitsspezialist',
  },

  aboutUs: {
    title: 'Über uns',
    subtitle: 'Unsere Geschichte',
    breadcrumb: 'Über uns',
    noWarBadge: 'Ein Stand für den Frieden',
    noWarTitle: 'Nein zum Krieg, Ja zum Leben',
    noWarSubtitle: 'Wir unterstützen keinen Tod eines Menschen. Wir stehen gegen chemische Waffen und jede Handlung, die das Gleichgewicht der Natur stört.',
    noWarP1: 'Echte Nachhaltigkeit erfordert, gegen jeden Schaden einzutreten, den Menschen einander und der Natur zufügen. Deshalb erklären wir offen unsere Opposition zu Krieg, Gewalt und chemischen Waffen.',
    noWarP2: 'Chemische Waffen verschmutzen Boden, Wasser und Luft. Gegen diese Werkzeuge zu sein, die die Atmosphäre stören und Lebewesen ihr Recht auf Leben entziehen, ist untrennbarer Teil unseres Respekts für unseren Planeten.',
    noWarP3: 'Bei FentyBarefoot tragen wir diesen Glauben in jedem Produkt und arbeiten daran, zukünftigen Generationen eine friedliche und grüne Welt zu hinterlassen.',
    noWarStat1: 'Antikrieg',
    noWarStat2: 'Gegen Chemische Waffen',
    noWarStat3: 'Naturschützer',
    noWarStat4: 'Lebensverteidiger',
    noWarQuote: 'Ohne Frieden gibt es keine Nachhaltigkeit. Sich gegen alles zu stellen, was der Menschheit und der Natur schadet, ist sowohl eine ethische als auch eine ökologische Verantwortung.',
  },

  categories: {
    'women-clothing': 'Damenkleidung',
    'women-shoes': 'Damenschuhe',
    'women-slippers': 'Damenhausschuhe',
    'women-sandals': 'Damensandalen',
    'women-combo': 'Damen Kombi',
    'women-clothing-tshirt': 'Damen T-Shirts',
    'women-clothing-pants': 'Damenhosen',
    'women-clothing-dress': 'Damenkleider',
    'women-clothing-kimono': 'Damen Kimonos',
    'women-clothing-crop': 'Damen Crop Tops',
    'women-clothing-shirt': 'Damenblusen',
    'women-clothing-skirt': 'Damenröcke',
    'women-clothing-shorts': 'Damen Shorts',
    'women-clothing-set': 'Damen-Sets',
    'women-clothing-suit': 'Damen Anzüge',
    'men-clothing': 'Herrenkleidung',
    'men-shoes': 'Herrenschuhe',
    'men-slippers': 'Herren Hausschuhe',
    'men-sandals': 'Herrensandalen',
    'men-combo': 'Herren Kombi',
    'men-clothing-tshirt': 'Herren T-Shirts',
    'men-clothing-pants': 'Herrenhosen',
    'men-clothing-shirt': 'Herrenhemden',
    'men-clothing-shorts': 'Herren Shorts',
    'men-clothing-suit': 'Herren Anzüge',
    combo: 'Kombi-Sets',
    women: 'Damen',
    men: 'Herren',
    'vegan-leather': 'Veganleder',
    'genuine-leather': 'Echtes Leder',
  },
};

export default common;